(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./node_modules/moment/locale sync recursive ^\\.\\/.*$":
/*!**************************************************!*\
  !*** ./node_modules/moment/locale sync ^\.\/.*$ ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "./node_modules/moment/locale/af.js",
	"./af.js": "./node_modules/moment/locale/af.js",
	"./ar": "./node_modules/moment/locale/ar.js",
	"./ar-dz": "./node_modules/moment/locale/ar-dz.js",
	"./ar-dz.js": "./node_modules/moment/locale/ar-dz.js",
	"./ar-kw": "./node_modules/moment/locale/ar-kw.js",
	"./ar-kw.js": "./node_modules/moment/locale/ar-kw.js",
	"./ar-ly": "./node_modules/moment/locale/ar-ly.js",
	"./ar-ly.js": "./node_modules/moment/locale/ar-ly.js",
	"./ar-ma": "./node_modules/moment/locale/ar-ma.js",
	"./ar-ma.js": "./node_modules/moment/locale/ar-ma.js",
	"./ar-sa": "./node_modules/moment/locale/ar-sa.js",
	"./ar-sa.js": "./node_modules/moment/locale/ar-sa.js",
	"./ar-tn": "./node_modules/moment/locale/ar-tn.js",
	"./ar-tn.js": "./node_modules/moment/locale/ar-tn.js",
	"./ar.js": "./node_modules/moment/locale/ar.js",
	"./az": "./node_modules/moment/locale/az.js",
	"./az.js": "./node_modules/moment/locale/az.js",
	"./be": "./node_modules/moment/locale/be.js",
	"./be.js": "./node_modules/moment/locale/be.js",
	"./bg": "./node_modules/moment/locale/bg.js",
	"./bg.js": "./node_modules/moment/locale/bg.js",
	"./bm": "./node_modules/moment/locale/bm.js",
	"./bm.js": "./node_modules/moment/locale/bm.js",
	"./bn": "./node_modules/moment/locale/bn.js",
	"./bn.js": "./node_modules/moment/locale/bn.js",
	"./bo": "./node_modules/moment/locale/bo.js",
	"./bo.js": "./node_modules/moment/locale/bo.js",
	"./br": "./node_modules/moment/locale/br.js",
	"./br.js": "./node_modules/moment/locale/br.js",
	"./bs": "./node_modules/moment/locale/bs.js",
	"./bs.js": "./node_modules/moment/locale/bs.js",
	"./ca": "./node_modules/moment/locale/ca.js",
	"./ca.js": "./node_modules/moment/locale/ca.js",
	"./cs": "./node_modules/moment/locale/cs.js",
	"./cs.js": "./node_modules/moment/locale/cs.js",
	"./cv": "./node_modules/moment/locale/cv.js",
	"./cv.js": "./node_modules/moment/locale/cv.js",
	"./cy": "./node_modules/moment/locale/cy.js",
	"./cy.js": "./node_modules/moment/locale/cy.js",
	"./da": "./node_modules/moment/locale/da.js",
	"./da.js": "./node_modules/moment/locale/da.js",
	"./de": "./node_modules/moment/locale/de.js",
	"./de-at": "./node_modules/moment/locale/de-at.js",
	"./de-at.js": "./node_modules/moment/locale/de-at.js",
	"./de-ch": "./node_modules/moment/locale/de-ch.js",
	"./de-ch.js": "./node_modules/moment/locale/de-ch.js",
	"./de.js": "./node_modules/moment/locale/de.js",
	"./dv": "./node_modules/moment/locale/dv.js",
	"./dv.js": "./node_modules/moment/locale/dv.js",
	"./el": "./node_modules/moment/locale/el.js",
	"./el.js": "./node_modules/moment/locale/el.js",
	"./en-SG": "./node_modules/moment/locale/en-SG.js",
	"./en-SG.js": "./node_modules/moment/locale/en-SG.js",
	"./en-au": "./node_modules/moment/locale/en-au.js",
	"./en-au.js": "./node_modules/moment/locale/en-au.js",
	"./en-ca": "./node_modules/moment/locale/en-ca.js",
	"./en-ca.js": "./node_modules/moment/locale/en-ca.js",
	"./en-gb": "./node_modules/moment/locale/en-gb.js",
	"./en-gb.js": "./node_modules/moment/locale/en-gb.js",
	"./en-ie": "./node_modules/moment/locale/en-ie.js",
	"./en-ie.js": "./node_modules/moment/locale/en-ie.js",
	"./en-il": "./node_modules/moment/locale/en-il.js",
	"./en-il.js": "./node_modules/moment/locale/en-il.js",
	"./en-nz": "./node_modules/moment/locale/en-nz.js",
	"./en-nz.js": "./node_modules/moment/locale/en-nz.js",
	"./eo": "./node_modules/moment/locale/eo.js",
	"./eo.js": "./node_modules/moment/locale/eo.js",
	"./es": "./node_modules/moment/locale/es.js",
	"./es-do": "./node_modules/moment/locale/es-do.js",
	"./es-do.js": "./node_modules/moment/locale/es-do.js",
	"./es-us": "./node_modules/moment/locale/es-us.js",
	"./es-us.js": "./node_modules/moment/locale/es-us.js",
	"./es.js": "./node_modules/moment/locale/es.js",
	"./et": "./node_modules/moment/locale/et.js",
	"./et.js": "./node_modules/moment/locale/et.js",
	"./eu": "./node_modules/moment/locale/eu.js",
	"./eu.js": "./node_modules/moment/locale/eu.js",
	"./fa": "./node_modules/moment/locale/fa.js",
	"./fa.js": "./node_modules/moment/locale/fa.js",
	"./fi": "./node_modules/moment/locale/fi.js",
	"./fi.js": "./node_modules/moment/locale/fi.js",
	"./fo": "./node_modules/moment/locale/fo.js",
	"./fo.js": "./node_modules/moment/locale/fo.js",
	"./fr": "./node_modules/moment/locale/fr.js",
	"./fr-ca": "./node_modules/moment/locale/fr-ca.js",
	"./fr-ca.js": "./node_modules/moment/locale/fr-ca.js",
	"./fr-ch": "./node_modules/moment/locale/fr-ch.js",
	"./fr-ch.js": "./node_modules/moment/locale/fr-ch.js",
	"./fr.js": "./node_modules/moment/locale/fr.js",
	"./fy": "./node_modules/moment/locale/fy.js",
	"./fy.js": "./node_modules/moment/locale/fy.js",
	"./ga": "./node_modules/moment/locale/ga.js",
	"./ga.js": "./node_modules/moment/locale/ga.js",
	"./gd": "./node_modules/moment/locale/gd.js",
	"./gd.js": "./node_modules/moment/locale/gd.js",
	"./gl": "./node_modules/moment/locale/gl.js",
	"./gl.js": "./node_modules/moment/locale/gl.js",
	"./gom-latn": "./node_modules/moment/locale/gom-latn.js",
	"./gom-latn.js": "./node_modules/moment/locale/gom-latn.js",
	"./gu": "./node_modules/moment/locale/gu.js",
	"./gu.js": "./node_modules/moment/locale/gu.js",
	"./he": "./node_modules/moment/locale/he.js",
	"./he.js": "./node_modules/moment/locale/he.js",
	"./hi": "./node_modules/moment/locale/hi.js",
	"./hi.js": "./node_modules/moment/locale/hi.js",
	"./hr": "./node_modules/moment/locale/hr.js",
	"./hr.js": "./node_modules/moment/locale/hr.js",
	"./hu": "./node_modules/moment/locale/hu.js",
	"./hu.js": "./node_modules/moment/locale/hu.js",
	"./hy-am": "./node_modules/moment/locale/hy-am.js",
	"./hy-am.js": "./node_modules/moment/locale/hy-am.js",
	"./id": "./node_modules/moment/locale/id.js",
	"./id.js": "./node_modules/moment/locale/id.js",
	"./is": "./node_modules/moment/locale/is.js",
	"./is.js": "./node_modules/moment/locale/is.js",
	"./it": "./node_modules/moment/locale/it.js",
	"./it-ch": "./node_modules/moment/locale/it-ch.js",
	"./it-ch.js": "./node_modules/moment/locale/it-ch.js",
	"./it.js": "./node_modules/moment/locale/it.js",
	"./ja": "./node_modules/moment/locale/ja.js",
	"./ja.js": "./node_modules/moment/locale/ja.js",
	"./jv": "./node_modules/moment/locale/jv.js",
	"./jv.js": "./node_modules/moment/locale/jv.js",
	"./ka": "./node_modules/moment/locale/ka.js",
	"./ka.js": "./node_modules/moment/locale/ka.js",
	"./kk": "./node_modules/moment/locale/kk.js",
	"./kk.js": "./node_modules/moment/locale/kk.js",
	"./km": "./node_modules/moment/locale/km.js",
	"./km.js": "./node_modules/moment/locale/km.js",
	"./kn": "./node_modules/moment/locale/kn.js",
	"./kn.js": "./node_modules/moment/locale/kn.js",
	"./ko": "./node_modules/moment/locale/ko.js",
	"./ko.js": "./node_modules/moment/locale/ko.js",
	"./ku": "./node_modules/moment/locale/ku.js",
	"./ku.js": "./node_modules/moment/locale/ku.js",
	"./ky": "./node_modules/moment/locale/ky.js",
	"./ky.js": "./node_modules/moment/locale/ky.js",
	"./lb": "./node_modules/moment/locale/lb.js",
	"./lb.js": "./node_modules/moment/locale/lb.js",
	"./lo": "./node_modules/moment/locale/lo.js",
	"./lo.js": "./node_modules/moment/locale/lo.js",
	"./lt": "./node_modules/moment/locale/lt.js",
	"./lt.js": "./node_modules/moment/locale/lt.js",
	"./lv": "./node_modules/moment/locale/lv.js",
	"./lv.js": "./node_modules/moment/locale/lv.js",
	"./me": "./node_modules/moment/locale/me.js",
	"./me.js": "./node_modules/moment/locale/me.js",
	"./mi": "./node_modules/moment/locale/mi.js",
	"./mi.js": "./node_modules/moment/locale/mi.js",
	"./mk": "./node_modules/moment/locale/mk.js",
	"./mk.js": "./node_modules/moment/locale/mk.js",
	"./ml": "./node_modules/moment/locale/ml.js",
	"./ml.js": "./node_modules/moment/locale/ml.js",
	"./mn": "./node_modules/moment/locale/mn.js",
	"./mn.js": "./node_modules/moment/locale/mn.js",
	"./mr": "./node_modules/moment/locale/mr.js",
	"./mr.js": "./node_modules/moment/locale/mr.js",
	"./ms": "./node_modules/moment/locale/ms.js",
	"./ms-my": "./node_modules/moment/locale/ms-my.js",
	"./ms-my.js": "./node_modules/moment/locale/ms-my.js",
	"./ms.js": "./node_modules/moment/locale/ms.js",
	"./mt": "./node_modules/moment/locale/mt.js",
	"./mt.js": "./node_modules/moment/locale/mt.js",
	"./my": "./node_modules/moment/locale/my.js",
	"./my.js": "./node_modules/moment/locale/my.js",
	"./nb": "./node_modules/moment/locale/nb.js",
	"./nb.js": "./node_modules/moment/locale/nb.js",
	"./ne": "./node_modules/moment/locale/ne.js",
	"./ne.js": "./node_modules/moment/locale/ne.js",
	"./nl": "./node_modules/moment/locale/nl.js",
	"./nl-be": "./node_modules/moment/locale/nl-be.js",
	"./nl-be.js": "./node_modules/moment/locale/nl-be.js",
	"./nl.js": "./node_modules/moment/locale/nl.js",
	"./nn": "./node_modules/moment/locale/nn.js",
	"./nn.js": "./node_modules/moment/locale/nn.js",
	"./pa-in": "./node_modules/moment/locale/pa-in.js",
	"./pa-in.js": "./node_modules/moment/locale/pa-in.js",
	"./pl": "./node_modules/moment/locale/pl.js",
	"./pl.js": "./node_modules/moment/locale/pl.js",
	"./pt": "./node_modules/moment/locale/pt.js",
	"./pt-br": "./node_modules/moment/locale/pt-br.js",
	"./pt-br.js": "./node_modules/moment/locale/pt-br.js",
	"./pt.js": "./node_modules/moment/locale/pt.js",
	"./ro": "./node_modules/moment/locale/ro.js",
	"./ro.js": "./node_modules/moment/locale/ro.js",
	"./ru": "./node_modules/moment/locale/ru.js",
	"./ru.js": "./node_modules/moment/locale/ru.js",
	"./sd": "./node_modules/moment/locale/sd.js",
	"./sd.js": "./node_modules/moment/locale/sd.js",
	"./se": "./node_modules/moment/locale/se.js",
	"./se.js": "./node_modules/moment/locale/se.js",
	"./si": "./node_modules/moment/locale/si.js",
	"./si.js": "./node_modules/moment/locale/si.js",
	"./sk": "./node_modules/moment/locale/sk.js",
	"./sk.js": "./node_modules/moment/locale/sk.js",
	"./sl": "./node_modules/moment/locale/sl.js",
	"./sl.js": "./node_modules/moment/locale/sl.js",
	"./sq": "./node_modules/moment/locale/sq.js",
	"./sq.js": "./node_modules/moment/locale/sq.js",
	"./sr": "./node_modules/moment/locale/sr.js",
	"./sr-cyrl": "./node_modules/moment/locale/sr-cyrl.js",
	"./sr-cyrl.js": "./node_modules/moment/locale/sr-cyrl.js",
	"./sr.js": "./node_modules/moment/locale/sr.js",
	"./ss": "./node_modules/moment/locale/ss.js",
	"./ss.js": "./node_modules/moment/locale/ss.js",
	"./sv": "./node_modules/moment/locale/sv.js",
	"./sv.js": "./node_modules/moment/locale/sv.js",
	"./sw": "./node_modules/moment/locale/sw.js",
	"./sw.js": "./node_modules/moment/locale/sw.js",
	"./ta": "./node_modules/moment/locale/ta.js",
	"./ta.js": "./node_modules/moment/locale/ta.js",
	"./te": "./node_modules/moment/locale/te.js",
	"./te.js": "./node_modules/moment/locale/te.js",
	"./tet": "./node_modules/moment/locale/tet.js",
	"./tet.js": "./node_modules/moment/locale/tet.js",
	"./tg": "./node_modules/moment/locale/tg.js",
	"./tg.js": "./node_modules/moment/locale/tg.js",
	"./th": "./node_modules/moment/locale/th.js",
	"./th.js": "./node_modules/moment/locale/th.js",
	"./tl-ph": "./node_modules/moment/locale/tl-ph.js",
	"./tl-ph.js": "./node_modules/moment/locale/tl-ph.js",
	"./tlh": "./node_modules/moment/locale/tlh.js",
	"./tlh.js": "./node_modules/moment/locale/tlh.js",
	"./tr": "./node_modules/moment/locale/tr.js",
	"./tr.js": "./node_modules/moment/locale/tr.js",
	"./tzl": "./node_modules/moment/locale/tzl.js",
	"./tzl.js": "./node_modules/moment/locale/tzl.js",
	"./tzm": "./node_modules/moment/locale/tzm.js",
	"./tzm-latn": "./node_modules/moment/locale/tzm-latn.js",
	"./tzm-latn.js": "./node_modules/moment/locale/tzm-latn.js",
	"./tzm.js": "./node_modules/moment/locale/tzm.js",
	"./ug-cn": "./node_modules/moment/locale/ug-cn.js",
	"./ug-cn.js": "./node_modules/moment/locale/ug-cn.js",
	"./uk": "./node_modules/moment/locale/uk.js",
	"./uk.js": "./node_modules/moment/locale/uk.js",
	"./ur": "./node_modules/moment/locale/ur.js",
	"./ur.js": "./node_modules/moment/locale/ur.js",
	"./uz": "./node_modules/moment/locale/uz.js",
	"./uz-latn": "./node_modules/moment/locale/uz-latn.js",
	"./uz-latn.js": "./node_modules/moment/locale/uz-latn.js",
	"./uz.js": "./node_modules/moment/locale/uz.js",
	"./vi": "./node_modules/moment/locale/vi.js",
	"./vi.js": "./node_modules/moment/locale/vi.js",
	"./x-pseudo": "./node_modules/moment/locale/x-pseudo.js",
	"./x-pseudo.js": "./node_modules/moment/locale/x-pseudo.js",
	"./yo": "./node_modules/moment/locale/yo.js",
	"./yo.js": "./node_modules/moment/locale/yo.js",
	"./zh-cn": "./node_modules/moment/locale/zh-cn.js",
	"./zh-cn.js": "./node_modules/moment/locale/zh-cn.js",
	"./zh-hk": "./node_modules/moment/locale/zh-hk.js",
	"./zh-hk.js": "./node_modules/moment/locale/zh-hk.js",
	"./zh-tw": "./node_modules/moment/locale/zh-tw.js",
	"./zh-tw.js": "./node_modules/moment/locale/zh-tw.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/moment/locale sync recursive ^\\.\\/.*$";

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<main fxFill>\r\n  <router-outlet></router-outlet>\r\n</main>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/signage-card/signage-card.component.html":
/*!***********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/signage-card/signage-card.component.html ***!
  \***********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>signage-card works!</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/booking-values-per-engineer/booking-values-per-engineer.component.html":
/*!*********************************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/booking-values-per-engineer/booking-values-per-engineer.component.html ***!
  \*********************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div\r\n  class=\"timestamp\"\r\n  [ngStyle.lt-xl]=\"{ fontSize: '1.2rem' }\"\r\n  [ngStyle.lt-md]=\"{ fontSize: '1rem' }\"\r\n>\r\n  {{ timeString }}\r\n</div>\r\n<div\r\n  class=\"chart\"\r\n  [ngStyle]=\"{\r\n    width: chartWidth.toString() + 'px',\r\n    margin: '1% auto 0'\r\n  }\"\r\n>\r\n  <svg\r\n    [attr.width]=\"chartWidth\"\r\n    [attr.height]=\"chartHeight\"\r\n    *ngIf=\"maxValue > 0\"\r\n  >\r\n    <defs>\r\n      <linearGradient id=\"backgroundGrad\" x1=\"0%\" y1=\"0%\" x2=\"0%\" y2=\"100%\">\r\n        <stop\r\n          [attr.offset]=\"'0%'\"\r\n          style=\"stop-color:rgb(0,255,0);stop-opacity:0.3\"\r\n        />\r\n        <stop\r\n          [attr.offset]=\"\r\n            ((1 - bottomOfGreen / maxValue) * 100).toString() + '%'\r\n          \"\r\n          style=\"stop-color:rgb(0,255,0);stop-opacity:0.3\"\r\n        />\r\n        <stop\r\n          [attr.offset]=\"((1 - topOfYellow / maxValue) * 100).toString() + '%'\"\r\n          style=\"stop-color:rgb(255, 255, 0);stop-opacity:0.3\"\r\n        />\r\n        <stop\r\n          [attr.offset]=\"\r\n            ((1 - bottomOfYellow / maxValue) * 100).toString() + '%'\r\n          \"\r\n          style=\"stop-color:rgb(255, 255, 0);stop-opacity:0.3\"\r\n        />\r\n        <stop\r\n          [attr.offset]=\"((1 - topOfRed / maxValue) * 100).toString() + '%'\"\r\n          style=\"stop-color:rgb(255,0,0);stop-opacity:0.3\"\r\n        />\r\n        <stop\r\n          [attr.offset]=\"'100%'\"\r\n          style=\"stop-color:rgb(255,0,0);stop-opacity:0.3\"\r\n        />\r\n      </linearGradient>\r\n    </defs>\r\n    <rect\r\n      [attr.width]=\"chartWidth\"\r\n      [attr.height]=\"chartHeight\"\r\n      fill=\"url(#backgroundGrad)\"\r\n    />\r\n    <g *ngFor=\"let person of bookingsData; let i = index\" [attr.index]=\"i\">\r\n      <line\r\n        [attr.x1]=\"20 + (i + 1 / 2) * columnWidth\"\r\n        [attr.y1]=\"25\"\r\n        [attr.x2]=\"20 + (i + 1 / 2) * columnWidth\"\r\n        [attr.y2]=\"chartHeight - 25\"\r\n        style=\"stroke:rgba(32,32,32,223);stroke-width:1\"\r\n      ></line>\r\n      <g *ngFor=\"let day of person.data; let j = index\" [attr.index]=\"j\">\r\n        <circle\r\n          [fxHide.lt-md]=\"true\"\r\n          [attr.cx]=\"20 + (i + 1 / 2) * columnWidth\"\r\n          [attr.cy]=\"(1 - day.value / maxValue) * (chartHeight - 50) + 25\"\r\n          [attr.r]=\"24 - j * 3\"\r\n          [attr.stroke]=\"'black'\"\r\n          [attr.stroke-width]=\"1\"\r\n          [attr.fill]=\"colourScheme.domain[j]\"\r\n        ></circle>\r\n        <circle\r\n          [fxHide.gt-sm]=\"true\"\r\n          [attr.cx]=\"20 + (i + 1 / 2) * columnWidth\"\r\n          [attr.cy]=\"(1 - day.value / maxValue) * (chartHeight - 50) + 25\"\r\n          [attr.r]=\"16 - j * 2\"\r\n          [attr.stroke]=\"'black'\"\r\n          [attr.stroke-width]=\"1\"\r\n          [attr.fill]=\"colourScheme.domain[j]\"\r\n        ></circle>\r\n      </g>\r\n    </g>\r\n  </svg>\r\n  <app-custom-x-axis\r\n    *ngIf=\"bookingsData\"\r\n    [view]=\"[chartWidth, 0]\"\r\n    [names]=\"bookingsData\"\r\n    [barPadding]=\"0\"\r\n  ></app-custom-x-axis>\r\n  <div\r\n    class=\"legend\"\r\n    [ngStyle.lt-md]=\"{\r\n      marginTop: '60px'\r\n    }\"\r\n  >\r\n    <app-custom-legend\r\n      [scheme]=\"colourScheme\"\r\n      [dataFormat]=\"'single'\"\r\n      [activeData]=\"activeData\"\r\n    ></app-custom-legend>\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/custom-guage-chart/custom-guage-chart.component.html":
/*!***************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/custom-guage-chart/custom-guage-chart.component.html ***!
  \***************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<ngx-charts-chart\r\n  [view]=\"[width, height]\"\r\n  [showLegend]=\"legend\"\r\n  [legendOptions]=\"legendOptions\"\r\n  [activeEntries]=\"activeEntries\"\r\n  [animations]=\"animations\"\r\n  (legendLabelClick)=\"onClick($event)\"\r\n  (legendLabelActivate)=\"onActivate($event)\"\r\n  (legendLabelDeactivate)=\"onDeactivate($event)\"\r\n>\r\n  <svg:g [attr.transform]=\"transform\" class=\"gauge chart\">\r\n    <svg:g\r\n      *ngFor=\"let arc of arcs; trackBy: trackBy\"\r\n      [attr.transform]=\"rotation\"\r\n    >\r\n      <svg:g\r\n        ngx-charts-gauge-arc\r\n        [backgroundArc]=\"arc.backgroundArc\"\r\n        [valueArc]=\"arc.valueArc\"\r\n        [cornerRadius]=\"cornerRadius\"\r\n        [colors]=\"colors\"\r\n        [isActive]=\"isActive(arc.valueArc.data)\"\r\n        [tooltipDisabled]=\"tooltipDisabled\"\r\n        [tooltipTemplate]=\"tooltipTemplate\"\r\n        [valueFormatting]=\"valueFormatting\"\r\n        [animations]=\"animations\"\r\n        (select)=\"onClick($event)\"\r\n        (activate)=\"onActivate($event)\"\r\n        (deactivate)=\"onDeactivate($event)\"\r\n      ></svg:g>\r\n    </svg:g>\r\n    <svg:g\r\n      ngx-charts-gauge-axis\r\n      *ngIf=\"showAxis\"\r\n      [bigSegments]=\"bigSegments\"\r\n      [smallSegments]=\"smallSegments\"\r\n      [min]=\"min\"\r\n      [max]=\"max\"\r\n      [radius]=\"outerRadius\"\r\n      [angleSpan]=\"angleSpan\"\r\n      [valueScale]=\"valueScale\"\r\n      [startAngle]=\"startAngle\"\r\n      [tickFormatting]=\"axisTickFormatting\"\r\n    ></svg:g>\r\n    <svg:text\r\n      #textEl\r\n      *ngIf=\"showText\"\r\n      [style.textAnchor]=\"'middle'\"\r\n      [attr.transform]=\"textTransform\"\r\n      alignment-baseline=\"central\"\r\n    >\r\n      <tspan x=\"0\" dy=\"0\">{{ displayValue }}</tspan>\r\n      <tspan x=\"0\" dy=\"1.2em\">{{ units }}</tspan>\r\n    </svg:text>\r\n  </svg:g>\r\n</ngx-charts-chart>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/custom-legend/custom-legend.component.html":
/*!*****************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/custom-legend/custom-legend.component.html ***!
  \*****************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"legend\">\r\n  <div class=\"body\">\r\n    <div\r\n      class=\"legendItem\"\r\n      *ngFor=\"let name of names; let i = index\"\r\n      [ngStyle]=\"{\r\n        marginBottom: names.length >= 10 ? '5px' : '10px'\r\n      }\"\r\n    >\r\n      <div\r\n        class=\"colour\"\r\n        [ngStyle]=\"{\r\n          background: colours[i % colours.length],\r\n          width: '25px',\r\n          height: '25px',\r\n          display: 'inline-block',\r\n          borderRadius: '13px',\r\n          position: 'relative',\r\n          bottom: '4px',\r\n          flexShrink: 0\r\n        }\"\r\n        [ngStyle.lt-md]=\"{\r\n          background: colours[i % colours.length],\r\n          width: '10px',\r\n          height: '10px',\r\n          display: 'inline-block',\r\n          borderRadius: '5px',\r\n          position: 'relative',\r\n          bottom: '4px',\r\n          flexShrink: 0\r\n        }\"\r\n      ></div>\r\n      <span\r\n        class=\"tag\"\r\n        [ngStyle.xl]=\"{ fontSize: '1.5rem' }\"\r\n        [ngStyle.lt-md]=\"{\r\n          marginLeft: '5px',\r\n          fontSize: '0.7rem'\r\n        }\"\r\n        >{{ name }}</span\r\n      >\r\n    </div>\r\n    <div class=\"legendItem\" *ngIf=\"totalsDisplayed\">\r\n      <span\r\n        class=\"tag\"\r\n        [ngStyle.xl]=\"{ fontSize: '1.5rem' }\"\r\n        [ngStyle.lt-md]=\"{\r\n          marginLeft: '5px',\r\n          fontSize: '0.7rem'\r\n        }\"\r\n      >\r\n        <span class=\"bold\">Bold</span> - Total {{ totalsUnits }}\r\n      </span>\r\n    </div>\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/custom-x-axis/custom-x-axis.component.html":
/*!*****************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/custom-x-axis/custom-x-axis.component.html ***!
  \*****************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"xAxis\">\r\n  <div\r\n    class=\"names\"\r\n    [ngStyle]=\"{\r\n      height: viewWidth,\r\n      width: '150px',\r\n      transform: 'rotate(-90deg)',\r\n      position: 'absolute',\r\n      top: namesTop,\r\n      left: namesLeft,\r\n      display: 'flex',\r\n      flexDirection: 'column',\r\n      justifyContent: 'space-between'\r\n    }\"\r\n  >\r\n    <div\r\n      class=\"name\"\r\n      *ngFor=\"let name of names\"\r\n      [ngStyle.lt-md]=\"{\r\n        textAlign: 'end',\r\n        fontSize: '0.8rem',\r\n        fontWeight: '500'\r\n      }\"\r\n    >\r\n      {{ name.firstname }}<br />{{ name.lastname }}\r\n    </div>\r\n  </div>\r\n  <div class=\"labels\" *ngIf=\"dataLabels && dataType && showDataLabels\">\r\n    <div\r\n      *ngIf=\"dataType === 'multi'\"\r\n      [ngStyle]=\"{ display: 'flex', width: '100%' }\"\r\n    >\r\n      <div\r\n        class=\"series\"\r\n        [ngStyle]=\"{\r\n          width: barWidth,\r\n          marginRight: barPaddingWidth,\r\n          display: 'inline-block',\r\n          fontSize: '1.5rem',\r\n          fontWeight: '500',\r\n          position: 'relative',\r\n          flexShrink: '0'\r\n        }\"\r\n        [ngStyle.lt-md]=\"{\r\n          width: barWidth,\r\n          marginRight: barPaddingWidth,\r\n          display: 'inline-block',\r\n          fontSize: '0.8rem',\r\n          fontWeight: '500',\r\n          position: 'relative',\r\n          flexShrink: '0'\r\n        }\"\r\n        *ngFor=\"let series of dataLabels\"\r\n      >\r\n        <div *ngFor=\"let label of series\">\r\n          <span\r\n            *ngIf=\"\r\n              label.barHeight >= 35 ||\r\n              (label.barHeight >= 22 && view[0] <= 1428) ||\r\n              (label.barHeight >= 15 && view[0] <= 1232)\r\n            \"\r\n            [ngStyle]=\"{\r\n              display: 'inline-block',\r\n              width: '100%',\r\n              position: 'absolute',\r\n              bottom: label.height,\r\n              left: '25px',\r\n              textAlign: 'center',\r\n              fontSize: '1.8rem',\r\n              fontWeigth: '400',\r\n              color: '#eeeeee',\r\n              textShadow:\r\n                '1px 1px #111111, -1px -1px #111111, -1px 1px #111111, 1px -1px #111111'\r\n            }\"\r\n            [ngStyle.lt-xl]=\"{\r\n              display: 'inline-block',\r\n              width: '100%',\r\n              position: 'absolute',\r\n              bottom: label.height,\r\n              left: '25px',\r\n              textAlign: 'center',\r\n              fontSize: '1.5rem',\r\n              fontWeigth: '400',\r\n              color: '#eeeeee',\r\n              textShadow:\r\n                '1px 1px #111111, -1px -1px #111111, -1px 1px #111111, 1px -1px #111111'\r\n            }\"\r\n            [ngStyle.lt-md]=\"{\r\n              display: 'inline-block',\r\n              width: '100%',\r\n              position: 'absolute',\r\n              bottom: label.height,\r\n              left: '25px',\r\n              textAlign: 'center',\r\n              fontSize: '0.8rem',\r\n              fontWeigth: '400',\r\n              color: '#eeeeee',\r\n              textShadow:\r\n                '1px 1px #111111, -1px -1px #111111, -1px 1px #111111, 1px -1px #111111'\r\n            }\"\r\n            >{{ label.display }}</span\r\n          >\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div\r\n      *ngIf=\"dataType === 'single'\"\r\n      [ngStyle]=\"{ display: 'flex', width: '100%' }\"\r\n    >\r\n      <div\r\n        *ngFor=\"let label of dataLabels\"\r\n        [ngStyle]=\"{\r\n          width: barWidth,\r\n          marginRight: barPaddingWidth,\r\n          display: 'inline-block',\r\n          position: 'relative',\r\n          flexShrink: '0'\r\n        }\"\r\n      >\r\n        <span\r\n          *ngIf=\"\r\n            (label.barHeight >= 35 && view[0] >= 1428) ||\r\n            (label.barHeight >= 20 && view[0] >= 1232.5) ||\r\n            label.barHeight >= 20\r\n          \"\r\n          [ngStyle]=\"{\r\n            display: 'inline-block',\r\n            width: '100%',\r\n            position: 'absolute',\r\n            bottom: label.height,\r\n            left: '25px',\r\n            textAlign: 'center',\r\n            fontSize: '1.8rem',\r\n            fontWeigth: '400',\r\n            color: '#eeeeee',\r\n            textShadow:\r\n              '1px 1px #111111, -1px -1px #111111, -1px 1px #111111, 1px -1px #111111'\r\n          }\"\r\n          [ngStyle.lt-xl]=\"{\r\n            display: 'inline-block',\r\n            width: '100%',\r\n            position: 'absolute',\r\n            bottom: label.height,\r\n            left: '25px',\r\n            textAlign: 'center',\r\n            fontSize: '1.5rem',\r\n            fontWeigth: '400',\r\n            color: '#eeeeee',\r\n            textShadow:\r\n              '1px 1px #111111, -1px -1px #111111, -1px 1px #111111, 1px -1px #111111',\r\n            flexShrink: '0'\r\n          }\"\r\n          [ngStyle.lt-md]=\"{\r\n            display: 'inline-block',\r\n            width: '100%',\r\n            position: 'absolute',\r\n            bottom: label.height,\r\n            left: '25px',\r\n            textAlign: 'center',\r\n            fontSize: '0.8rem',\r\n            fontWeigth: '400',\r\n            color: '#eeeeee',\r\n            textShadow:\r\n              '1px 1px #111111, -1px -1px #111111, -1px 1px #111111, 1px -1px #111111',\r\n            flexShrink: '0'\r\n          }\"\r\n          >{{ label.display }}</span\r\n        >\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div\r\n    class=\"totals\"\r\n    *ngIf=\"showTotals && totals\"\r\n    [ngStyle]=\"{ display: 'flex', width: '100%' }\"\r\n  >\r\n    <div\r\n      class=\"total\"\r\n      *ngFor=\"let total of totals\"\r\n      [ngStyle]=\"{\r\n        width: barWidth,\r\n        marginRight: barPaddingWidth,\r\n        display: 'inline-block',\r\n        position: 'relative',\r\n        flexShrink: '0'\r\n      }\"\r\n    >\r\n      <span\r\n        [ngStyle]=\"{\r\n          display: 'inline-block',\r\n          width: '100%',\r\n          position: 'absolute',\r\n          bottom: total.heightString,\r\n          left: '25px',\r\n          textAlign: 'center',\r\n          fontSize: '1.8rem',\r\n          fontWeigth: '400',\r\n          textShadow: '1px 1px #111111, -1px 1px #111111',\r\n          flexShrink: '0'\r\n        }\"\r\n        [ngStyle.lt-xl]=\"{\r\n          display: 'inline-block',\r\n          width: '100%',\r\n          position: 'absolute',\r\n          bottom: total.heightString,\r\n          left: '25px',\r\n          textAlign: 'center',\r\n          fontSize: '1.5rem',\r\n          fontWeigth: '400',\r\n          textShadow: '1px 1px #111111, -1px 1px #111111',\r\n          flexShrink: '0'\r\n        }\"\r\n        [ngStyle.lt-md]=\"{\r\n          display: 'inline-block',\r\n          width: '100%',\r\n          position: 'absolute',\r\n          bottom: total.heightString,\r\n          left: '25px',\r\n          textAlign: 'center',\r\n          fontSize: '1.2rem',\r\n          fontWeigth: '400',\r\n          textShadow: '1px 1px #111111, -1px 1px #111111',\r\n          flexShrink: '0'\r\n        }\"\r\n        >{{ total.value }}</span\r\n      >\r\n    </div>\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/custom-y-axis/custom-y-axis.component.html":
/*!*****************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/custom-y-axis/custom-y-axis.component.html ***!
  \*****************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"container\">\r\n  <div class=\"label\">\r\n    <h2\r\n      [ngStyle]=\"{\r\n        transform: 'rotate(-90deg)',\r\n        display: 'inline-block',\r\n        height: '30px',\r\n        width: totalHeight,\r\n        position: 'relative',\r\n        right: labelPos,\r\n        top: labelPos\r\n      }\"\r\n      [ngStyle.lt-md]=\"{\r\n        transform: 'rotate(-90deg)',\r\n        display: 'inline-block',\r\n        height: '30px',\r\n        width: totalHeight,\r\n        position: 'relative',\r\n        right: labelPos,\r\n        top: labelPos,\r\n        fontSize: '0.7rem'\r\n      }\"\r\n    >\r\n      {{ label }}\r\n    </h2>\r\n  </div>\r\n  <div\r\n    class=\"ticks\"\r\n    [ngStyle]=\"{\r\n      height: tickArrayHeight,\r\n      minWidth: '45%',\r\n      marginTop: tickArrayMargin,\r\n      position: 'relative',\r\n      right: '20%',\r\n      display: 'flex',\r\n      flexDirection: 'column',\r\n      justifyContent: 'space-between'\r\n    }\"\r\n  >\r\n    <div\r\n      class=\"tick\"\r\n      *ngFor=\"let tick of tickArray\"\r\n      [ngStyle.lt-md]=\"{ fontSize: '0.7rem' }\"\r\n    >\r\n      {{ tick }}\r\n    </div>\r\n  </div>\r\n  <div\r\n    class=\"tickLines\"\r\n    [ngStyle]=\"{\r\n      height: tickLinesHeight,\r\n      marginTop: tickLinesMargin,\r\n      display: 'flex',\r\n      flexDirection: 'column',\r\n      justifyContent: 'space-between'\r\n    }\"\r\n  >\r\n    <div\r\n      class=\"tickLine\"\r\n      *ngFor=\"let tick of tickArray\"\r\n      [ngStyle]=\"{ width: tickLineWidth }\"\r\n    ></div>\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/jobs-not-completed/jobs-not-completed.component.html":
/*!***************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/jobs-not-completed/jobs-not-completed.component.html ***!
  \***************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div\r\n  class=\"timestamp\"\r\n  [ngStyle.lt-xl]=\"{ fontSize: '1.2rem' }\"\r\n  [ngStyle.lt-md]=\"{ fontSize: '1rem' }\"\r\n>\r\n  {{ timeString }}\r\n</div>\r\n<div class=\"cardContainer\">\r\n  <div *ngIf=\"jobsData && jobsData.length > 0; else noData\">\r\n    <div\r\n      *ngFor=\"let card of jobsData\"\r\n      class=\"jobCard\"\r\n      [ngStyle]=\"{\r\n        width: this.cardDims[0],\r\n        height: this.cardDims[1]\r\n      }\"\r\n    >\r\n      <div class=\"title\" *ngIf=\"cardDims === small; else greaterThanSmall\">\r\n        <div class=\"jobNumber\">\r\n          {{ card.jobName.split(\" - \")[0] }}\r\n        </div>\r\n      </div>\r\n      <ng-template #greaterThanSmall\r\n        ><div class=\"title\">\r\n          <div class=\"titleContent\">\r\n            <div class=\"jobNumber\">{{ card.jobName.split(\" - \")[0] }}</div>\r\n            {{ card.jobName.split(\" - \")[1] }}\r\n            <span *ngIf=\"card.jobName.split(' - ')[2]\">\r\n              - {{ card.jobName.split(\" - \")[2]\r\n              }}<span *ngIf=\"card.jobName.split(' - ')[3]\">\r\n                - {{ card.jobName.split(\" - \")[3] }}</span\r\n              ></span\r\n            >\r\n          </div>\r\n        </div></ng-template\r\n      >\r\n      <div class=\"engineers\" *ngIf=\"cardDims === large || cardDims === largest\">\r\n        <div class=\"heading\">\r\n          Engineer<span *ngIf=\"card.engineers.length > 1\">s</span>:\r\n        </div>\r\n        <div *ngFor=\"let engineer of card.engineers\">\r\n          {{ engineer.firstname }} {{ engineer.lastname }}\r\n        </div>\r\n      </div>\r\n      <div class=\"lastStatus\" *ngIf=\"cardDims === largest\">\r\n        <div class=\"heading\">Last Status:</div>\r\n        {{ card.status }}\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <ng-template #noData\r\n    ><div class=\"noData\">\r\n      There were no jobs not completed in the app yesterday found!\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/jobs/jobs.component.html":
/*!***********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/jobs/jobs.component.html ***!
  \***********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"flex-container\">\r\n  <div\r\n    [ngStyle]=\"{\r\n      width: '99%',\r\n      height: '100%',\r\n      position: 'absolute',\r\n      top: '0',\r\n      left: '1%'\r\n    }\"\r\n  >\r\n    <div\r\n      class=\"timestamp\"\r\n      [ngStyle.lt-xl]=\"{ fontSize: '1.2rem' }\"\r\n      [ngStyle.lt-md]=\"{ fontSize: '1rem' }\"\r\n    >\r\n      {{ timeString }}\r\n    </div>\r\n  </div>\r\n  <div class=\"chart-container\">\r\n    <h1\r\n      [ngStyle.md]=\"{\r\n        fontSize: '1.3rem'\r\n      }\"\r\n      [ngStyle.lt-md]=\"{\r\n        fontSize: '0.8rem'\r\n      }\"\r\n    >\r\n      Jobs Booked Per Person Today\r\n    </h1>\r\n    <app-custom-guage-chart\r\n      *ngIf=\"data && usersData\"\r\n      [results]=\"data.bookingsData\"\r\n      [max]=\"data.maxValueBooked\"\r\n      [customColors]=\"usersData\"\r\n      [showText]=\"showText\"\r\n      units=\"Booked\"\r\n    ></app-custom-guage-chart>\r\n  </div>\r\n  <div class=\"chart-container\">\r\n    <h1\r\n      [ngStyle.md]=\"{\r\n        fontSize: '1.3rem'\r\n      }\"\r\n      [ngStyle.lt-md]=\"{\r\n        fontSize: '0.8rem'\r\n      }\"\r\n    >\r\n      Jobs Added Per Person Today\r\n    </h1>\r\n    <app-custom-guage-chart\r\n      *ngIf=\"data && usersData\"\r\n      [results]=\"data.jobsData\"\r\n      [max]=\"data.maxValueAdded\"\r\n      [customColors]=\"usersData\"\r\n      [showText]=\"showText\"\r\n      units=\"Added\"\r\n    ></app-custom-guage-chart>\r\n  </div>\r\n</div>\r\n<app-custom-legend\r\n  *ngIf=\"data && usersData\"\r\n  [dataFormat]=\"dataFormat\"\r\n  [activeData]=\"this.data.jobsData.concat(this.data.bookingsData)\"\r\n  [customColours]=\"usersData\"\r\n></app-custom-legend>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/outstanding-tasks-per-group/outstanding-tasks-per-group.component.html":
/*!*********************************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/outstanding-tasks-per-group/outstanding-tasks-per-group.component.html ***!
  \*********************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"container\">\r\n  <div\r\n    class=\"timestamp\"\r\n    [ngStyle.lt-xl]=\"{ fontSize: '1.2rem' }\"\r\n    [ngStyle.lt-md]=\"{ fontSize: '1rem' }\"\r\n  >\r\n    {{ timeString }}\r\n  </div>\r\n  <div class=\"subtitle\">\r\n    <h1\r\n      [ngStyle.md]=\"{\r\n        fontSize: '1.3rem'\r\n      }\"\r\n      [ngStyle.lt-md]=\"{\r\n        fontSize: '0.8rem'\r\n      }\"\r\n    >\r\n      {{ subtitle }}\r\n    </h1>\r\n  </div>\r\n  <div class=\"users\">\r\n    <div class=\"userGauge\">\r\n      <app-custom-guage-chart\r\n        [ngStyle.md]=\"{ left: '0' }\"\r\n        *ngIf=\"outstandingData && usersData\"\r\n        [view]=\"userGaugeDims\"\r\n        [results]=\"outstandingData.reds\"\r\n        [max]=\"outstandingData.maxValueReds\"\r\n        [customColors]=\"usersData\"\r\n        [textValue]=\"'Reds'\"\r\n        [showAxis]=\"showAxis\"\r\n        [angleSpan]=\"90\"\r\n        [startAngle]=\"-90\"\r\n      ></app-custom-guage-chart>\r\n    </div>\r\n    <div class=\"userGauge\">\r\n      <app-custom-guage-chart\r\n        [ngStyle.md]=\"{ left: '0' }\"\r\n        *ngIf=\"outstandingData && usersData\"\r\n        [view]=\"userGaugeDims\"\r\n        [results]=\"outstandingData.ambers\"\r\n        [max]=\"outstandingData.maxValueAmbers\"\r\n        [customColors]=\"usersData\"\r\n        [textValue]=\"'Ambers'\"\r\n        [showAxis]=\"showAxis\"\r\n        [angleSpan]=\"90\"\r\n        [startAngle]=\"-90\"\r\n      ></app-custom-guage-chart>\r\n    </div>\r\n    <div class=\"userGauge\">\r\n      <app-custom-guage-chart\r\n        [ngStyle.md]=\"{ left: '0' }\"\r\n        *ngIf=\"outstandingData && usersData\"\r\n        [view]=\"userGaugeDims\"\r\n        [results]=\"outstandingData.greens\"\r\n        [max]=\"outstandingData.maxValueGreens\"\r\n        [customColors]=\"usersData\"\r\n        [textValue]=\"'Greens'\"\r\n        [showAxis]=\"showAxis\"\r\n        [angleSpan]=\"90\"\r\n        [startAngle]=\"-90\"\r\n      ></app-custom-guage-chart>\r\n    </div>\r\n  </div>\r\n  <div class=\"main\">\r\n    <app-custom-guage-chart\r\n      *ngIf=\"outstandingData\"\r\n      [results]=\"outstandingData.groupValues\"\r\n      [max]=\"outstandingData.maxValueGroup\"\r\n      [scheme]=\"colourScheme\"\r\n      [units]=\"'Group Total'\"\r\n    ></app-custom-guage-chart>\r\n  </div>\r\n  <div class=\"overdues\" *ngIf=\"overdueData\">\r\n    <h2\r\n      class=\"sectionTitle\"\r\n      [ngStyle.xl]=\"{ fontSize: '1.3rem' }\"\r\n      [ngStyle.lt-md]=\"{ fontSize: '0.8rem', top: '0px' }\"\r\n    >\r\n      Overdue (Days)\r\n    </h2>\r\n    <div\r\n      class=\"row topRow\"\r\n      [ngStyle.lt-md]=\"{ position: 'relative', bottom: '10px' }\"\r\n    >\r\n      <h3\r\n        class=\"rowItem\"\r\n        [ngStyle.lt-lg]=\"{ fontSize: '1.2rem', width: '100%', margin: 0 }\"\r\n        [ngStyle.lt-md]=\"{ fontSize: '0.7rem', width: '100%', margin: 0 }\"\r\n      >\r\n        Name\r\n      </h3>\r\n      <h3\r\n        class=\"rowItem\"\r\n        [ngStyle.lt-lg]=\"{\r\n          fontSize: '1.2rem',\r\n          width: '50%',\r\n          margin: 0,\r\n          position: 'relative',\r\n          bottom: '5px'\r\n        }\"\r\n        [ngStyle.lt-md]=\"{\r\n          fontSize: '0.7rem',\r\n          width: '50%',\r\n          margin: 0,\r\n          position: 'relative',\r\n          bottom: '5px'\r\n        }\"\r\n      >\r\n        Oldest\r\n      </h3>\r\n      <h3\r\n        class=\"rowItem\"\r\n        [ngStyle.lt-lg]=\"{\r\n          fontSize: '1.2rem',\r\n          width: '50%',\r\n          margin: 0,\r\n          position: 'relative',\r\n          bottom: '5px'\r\n        }\"\r\n        [ngStyle.lt-md]=\"{\r\n          fontSize: '0.7rem',\r\n          width: '50%',\r\n          margin: 0,\r\n          position: 'relative',\r\n          bottom: '5px'\r\n        }\"\r\n      >\r\n        Average\r\n      </h3>\r\n    </div>\r\n    <div\r\n      class=\"row\"\r\n      [ngStyle.lt-md]=\"{ minHeight: '20px' }\"\r\n      [ngStyle.md]=\"{ minHeight: '35px' }\"\r\n      [ngStyle.lg]=\"{ minHeight: '45px' }\"\r\n      [ngStyle.xl]=\"{ minHeight: '55px' }\"\r\n      *ngFor=\"let person of overdueData\"\r\n    >\r\n      <div\r\n        class=\"rowItem\"\r\n        [ngStyle]=\"{\r\n          display: 'inline-flex',\r\n          flexWrap: 'nowrap',\r\n          position: 'relative',\r\n          bottom: '15px'\r\n        }\"\r\n        [ngStyle.lt-lg]=\"{\r\n          display: 'inline-flex',\r\n          flexWrap: 'nowrap',\r\n          position: 'relative',\r\n          bottom: '10px',\r\n          width: '100%'\r\n        }\"\r\n      >\r\n        <span\r\n          class=\"userColour\"\r\n          [ngStyle]=\"{\r\n            background: person.value,\r\n            position: 'relative',\r\n            top: '10px',\r\n            width: '25px',\r\n            height: '25px',\r\n            display: 'inline-block',\r\n            borderRadius: '13px',\r\n            flexShrink: 0\r\n          }\"\r\n          [ngStyle.lt-md]=\"{\r\n            background: person.value,\r\n            width: '10px',\r\n            height: '10px',\r\n            display: 'block',\r\n            borderRadius: '5px',\r\n            position: 'relative',\r\n            top: '2px',\r\n            flexShrink: 0\r\n          }\"\r\n        ></span\r\n        ><span\r\n          class=\"name\"\r\n          [ngStyle.lt-lg]=\"{ fontSize: '1.2rem' }\"\r\n          [ngStyle.lt-md]=\"{ fontSize: '0.7rem' }\"\r\n          >{{ person.firstname }}<br [fxHide.lt-lg]=\"true\" />\r\n          {{ person.lastname }}</span\r\n        >\r\n      </div>\r\n      <div\r\n        class=\"rowItem\"\r\n        [ngStyle.lt-lg]=\"{\r\n          fontSize: '1.2rem',\r\n          width: '49%',\r\n          position: 'relative',\r\n          bottom: '15px'\r\n        }\"\r\n        [ngStyle.lt-md]=\"{\r\n          fontSize: '0.7rem',\r\n          width: '49%',\r\n          position: 'relative',\r\n          bottom: '15px'\r\n        }\"\r\n      >\r\n        {{ person.oldest }}\r\n      </div>\r\n      <div\r\n        class=\"rowItem\"\r\n        [ngStyle.lt-lg]=\"{\r\n          fontSize: '1.2rem',\r\n          width: '49%',\r\n          position: 'relative',\r\n          bottom: '15px'\r\n        }\"\r\n        [ngStyle.lt-md]=\"{\r\n          fontSize: '0.7rem',\r\n          width: '49%',\r\n          position: 'relative',\r\n          bottom: '15px'\r\n        }\"\r\n      >\r\n        {{ person.average }}\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/predicted-reds-ambers-per-user/predicted-reds-ambers-per-user.component.html":
/*!***************************************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/predicted-reds-ambers-per-user/predicted-reds-ambers-per-user.component.html ***!
  \***************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div\n  class=\"timestamp\"\n  [ngStyle.lt-xl]=\"{ fontSize: '1.2rem' }\"\n  [ngStyle.lt-md]=\"{ fontSize: '1rem' }\"\n>\n  {{ timeString }}\n</div>\n<div class=\"subtitle\">\n  <h1\n    [ngStyle.md]=\"{\n      fontSize: '1.3rem'\n    }\"\n    [ngStyle.lt-md]=\"{\n      fontSize: '0.8rem'\n    }\"\n  >\n    {{ subtitle }}\n  </h1>\n</div>\n<div class=\"chart\">\n  <svg\n    *ngIf=\"maxValue && predictionsData && usersData && maxValue > 0\"\n    [attr.width]=\"viewWidth\"\n    [attr.height]=\"viewHeight\"\n  >\n    <g\n      class=\"yAxis\"\n      [attr.x]=\"0\"\n      [attr.y]=\"0\"\n      [attr.width]=\"yAxisWidth\"\n      [attr.height]=\"chartHeight\"\n    >\n      <g\n        class=\"yAxisTag\"\n        [ngStyle.lg]=\"{ fontSize: '1.1rem' }\"\n        [ngStyle.md]=\"{ fontSize: '1rem' }\"\n        [ngStyle.lt-md]=\"{ fontSize: '0.8rem' }\"\n        *ngFor=\"let row of rows; let i = index\"\n        [attr.index]=\"i\"\n      >\n        <text\n          [attr.x]=\"yAxisWidth - 20\"\n          [attr.y]=\"chartHeight - 20 - (i * 2 + 1) * rowHeight\"\n          [attr.width]=\"yAxisWidth\"\n          [attr.height]=\"rowHeight\"\n        >\n          <tspan [attr.x]=\"yAxisWidth - 20\" [attr.dy]=\"'1.2em'\">\n            {{ row.day.split(\" \")[0] }}\n          </tspan>\n          <tspan [attr.x]=\"yAxisWidth - 20\" [attr.dy]=\"'1.2em'\">\n            {{ row.day.split(\" \")[1] }}\n          </tspan>\n        </text>\n      </g>\n    </g>\n    <g class=\"graphBody\" [attr.x]=\"yAxisWidth\" [attr.y]=\"0\">\n      <g *ngFor=\"let row of rows; let i = index\" [attr.index]=\"i\">\n        <g class=\"amber\">\n          <rect\n            [attr.x]=\"yAxisWidth\"\n            [attr.y]=\"chartHeight - (i * 2 + 1) * rowHeight\"\n            [attr.width]=\"chartWidth\"\n            [attr.height]=\"rowHeight\"\n            fill=\"rgba(242, 183, 100, 100)\"\n          ></rect>\n          <g *ngFor=\"let user of predictionsData.predictionsData\">\n            <circle\n              [attr.cx]=\"\n                yAxisWidth +\n                21 +\n                (user.predictedAmbersByDay[i].estimateAmber / maxValue) *\n                  (chartWidth - 42)\n              \"\n              [attr.cy]=\"chartHeight - (i * 2 + 1 / 2) * rowHeight\"\n              [attr.r]=\"circleRadius\"\n              [attr.stroke]=\"'black'\"\n              [attr.stroke-width]=\"1\"\n              [attr.fill]=\"user.colour\"\n            ></circle>\n          </g>\n        </g>\n        <g class=\"red\">\n          <rect\n            [attr.x]=\"yAxisWidth\"\n            [attr.y]=\"chartHeight - (i + 1) * 2 * rowHeight\"\n            [attr.width]=\"chartWidth\"\n            [attr.height]=\"rowHeight\"\n            fill=\"rgba(226, 125, 121, 100)\"\n          ></rect>\n          <g *ngFor=\"let user of predictionsData.predictionsData\">\n            <circle\n              [attr.cx]=\"\n                yAxisWidth +\n                21 +\n                (user.predictedRedsByDay[i].estimateRed / maxValue) *\n                  (chartWidth - 42)\n              \"\n              [attr.cy]=\"chartHeight - (i * 2 + 3 / 2) * rowHeight\"\n              [attr.r]=\"circleRadius\"\n              [attr.stroke]=\"'black'\"\n              [attr.stroke-width]=\"1\"\n              [attr.fill]=\"user.colour\"\n            ></circle>\n          </g>\n        </g>\n      </g>\n    </g>\n    <g class=\"xAxis\" [attr.x]=\"yAxisWidth\" [attr.y]=\"chartHeight\">\n      <g\n        class=\"xAxisTick\"\n        [ngStyle.lg]=\"{ fontSize: '1.1rem' }\"\n        [ngStyle.md]=\"{ fontSize: '1rem' }\"\n        [ngStyle.lt-md]=\"{ fontSize: '0.8rem' }\"\n        *ngFor=\"let tick of xTicks\"\n      >\n        <text\n          [attr.x]=\"yAxisWidth + 21 + (tick / maxValue) * (chartWidth - 42)\"\n          [attr.y]=\"chartHeight + 20\"\n        >\n          {{ tick }}\n        </text>\n      </g>\n    </g>\n  </svg>\n  <div class=\"legend\">\n    <app-custom-legend\n      *ngIf=\"predictionsData && usersData\"\n      [activeData]=\"predictionsData.predictionsData\"\n      [dataFormat]=\"'single'\"\n      [customColours]=\"usersData\"\n    ></app-custom-legend>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/signage-slider/signage-slider.component.html":
/*!*******************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/signage-slider/signage-slider.component.html ***!
  \*******************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"container\" [ngStyle.lt-lg]=\"{ overflow: 'scroll' }\">\r\n  <div\r\n    class=\"topBar\"\r\n    [ngStyle.lt-md]=\"{\r\n      display: 'flex',\r\n      textAlign: 'center',\r\n      width: '100%',\r\n      height: '15%',\r\n      justifyContent: 'space-around'\r\n    }\"\r\n    [ngStyle.md]=\"{\r\n      display: 'flex',\r\n      textAlign: 'center',\r\n      width: '100%',\r\n      height: '10%',\r\n      justifyContent: 'space-around'\r\n    }\"\r\n  >\r\n    <div class=\"topBarItem\">\r\n      <h3\r\n        class=\"prev\"\r\n        *ngIf=\"previousString\"\r\n        [ngStyle.lt-md]=\"{ fontSize: '0.8rem', fontWeight: '600' }\"\r\n        [fxHide.lt-md]=\"true\"\r\n      >\r\n        <span [ngStyle.md]=\"{ fontSize: '0.9rem' }\">{{ previousString }}</span>\r\n      </h3>\r\n    </div>\r\n    <div\r\n      class=\"topBarItem\"\r\n      [ngStyle.lt-md]=\"{ fontSize: '0.6rem' }\"\r\n      [ngStyle.md]=\"{\r\n        fontSize: '0.9rem'\r\n      }\"\r\n    >\r\n      <h1>\r\n        {{ titleString\r\n        }}<span *ngIf=\"titleString === 'Jobs Not Complete'\">\r\n          In App Yesterday</span\r\n        ><span *ngIf=\"titleString === 'Jobs'\"> Booked And Added</span>\r\n      </h1>\r\n    </div>\r\n    <div class=\"topBarItem\">\r\n      <h3\r\n        class=\"next\"\r\n        *ngIf=\"nextString\"\r\n        [ngStyle.lt-md]=\"{ fontSize: '0.8rem', fontWeight: '600' }\"\r\n      >\r\n        <span [fxHide.lt-md]=\"true\" [ngStyle.md]=\"{ fontSize: '0.9rem' }\"\r\n          >{{ nextString }} -\r\n        </span>\r\n        <span\r\n          class=\"timer\"\r\n          [ngStyle.lt-md]=\"{ position: 'relative', top: '3px', right: '3px' }\"\r\n          [ngStyle.md]=\"{ fontSize: '0.9rem' }\"\r\n          >{{ timer | number: \"1.0-0\" }}s</span\r\n        >\r\n      </h3>\r\n      <div\r\n        class=\"timeBar\"\r\n        [ngStyle.lt-md]=\"{\r\n          width: '75%',\r\n          height: '11px',\r\n          backgroundColor: '#4fc9a1',\r\n          borderRadius: '0 0 11px 0',\r\n          margin: '0 auto'\r\n        }\"\r\n        [ngStyle]=\"{\r\n          width: '50%',\r\n          height: '11px',\r\n          backgroundColor: '#4fc9a1',\r\n          borderRadius: '0 0 11px 0',\r\n          margin: '0 auto'\r\n        }\"\r\n      >\r\n        <div\r\n          class=\"timeLeft\"\r\n          [ngStyle]=\"{\r\n            width: timeLeftString,\r\n            height: '11px',\r\n            backgroundColor: '#583979',\r\n            borderRadius: '0 0 11px 0'\r\n          }\"\r\n        ></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div\r\n    class=\"childElement\"\r\n    [ngStyle.md]=\"{ height: '90%' }\"\r\n    [ngStyle.lt-md]=\"{ height: '85%' }\"\r\n    [ngSwitch]=\"titleString\"\r\n  >\r\n    <app-system-generated-tasks-per-user\r\n      *ngSwitchCase=\"'Tasks Complete'\"\r\n      [subtitle]=\"subtitleString\"\r\n    ></app-system-generated-tasks-per-user>\r\n    <app-outstanding-tasks-per-group\r\n      *ngSwitchCase=\"'Tasks Outstanding'\"\r\n      [subtitle]=\"subtitleString\"\r\n    ></app-outstanding-tasks-per-group>\r\n    <app-jobs *ngSwitchCase=\"'Jobs'\"></app-jobs>\r\n    <app-jobs-not-completed\r\n      *ngSwitchCase=\"'Jobs Not Complete'\"\r\n    ></app-jobs-not-completed>\r\n    <app-booking-values-per-engineer\r\n      *ngSwitchCase=\"'Booking Values'\"\r\n      [page]=\"subtitleString\"\r\n    ></app-booking-values-per-engineer>\r\n    <app-predicted-reds-ambers-per-user\r\n      *ngSwitchCase=\"'Predicted KPI Changes'\"\r\n      [subtitle]=\"subtitleString\"\r\n    ></app-predicted-reds-ambers-per-user>\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/system-generated-tasks-per-user/system-generated-tasks-per-user.component.html":
/*!*****************************************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/system-generated-tasks-per-user/system-generated-tasks-per-user.component.html ***!
  \*****************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"container\">\r\n  <div\r\n    class=\"timestamp\"\r\n    [ngStyle.lt-xl]=\"{ fontSize: '1.2rem' }\"\r\n    [ngStyle.lt-md]=\"{ fontSize: '1rem' }\"\r\n  >\r\n    {{ timeString }}\r\n  </div>\r\n  <div class=\"subtitle\">\r\n    <h1\r\n      [ngStyle.md]=\"{\r\n        fontSize: '1.3rem'\r\n      }\"\r\n      [ngStyle.lt-md]=\"{\r\n        fontSize: '0.8rem'\r\n      }\"\r\n    >\r\n      {{ subtitle }}\r\n    </h1>\r\n  </div>\r\n  <div class=\"yAxis\" [ngStyle]=\"{ width: '10%', height: yAxisHeight }\">\r\n    <app-custom-y-axis\r\n      *ngIf=\"typesData\"\r\n      [view]=\"view\"\r\n      [label]=\"yAxisLabel\"\r\n      [maxValue]=\"typesData.maxValue\"\r\n    ></app-custom-y-axis>\r\n  </div>\r\n  <div class=\"graphBody\">\r\n    <ngx-charts-bar-vertical-stacked\r\n      *ngIf=\"typesData\"\r\n      [view]=\"view\"\r\n      [scheme]=\"colourScheme\"\r\n      [results]=\"typesData.result\"\r\n      [barPadding]=\"barPadding\"\r\n    ></ngx-charts-bar-vertical-stacked>\r\n    <app-custom-x-axis\r\n      *ngIf=\"typesData\"\r\n      [view]=\"view\"\r\n      [names]=\"typesData.names\"\r\n      [dataLabels]=\"labels\"\r\n      [totals]=\"totals\"\r\n      [showDataLabels]=\"showDataLabels\"\r\n      [showTotals]=\"true\"\r\n      [dataType]=\"dataType\"\r\n      [labelFormat]=\"labelFormat\"\r\n      [maxValue]=\"typesData.maxValue\"\r\n      [barPadding]=\"barPadding\"\r\n    ></app-custom-x-axis>\r\n  </div>\r\n  <div\r\n    class=\"legend\"\r\n    [ngStyle.lt-md]=\"{\r\n      marginTop: '60px'\r\n    }\"\r\n  >\r\n    <app-custom-legend\r\n      *ngIf=\"typesData\"\r\n      [activeData]=\"typesData.result\"\r\n      [dataFormat]=\"dataType\"\r\n      [scheme]=\"colourScheme.domain\"\r\n      [totalsDisplayed]=\"true\"\r\n      [totalsUnits]=\"'Tasks Complete'\"\r\n    ></app-custom-legend>\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/pages/administrators/administrators.component.html":
/*!**************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/pages/administrators/administrators.component.html ***!
  \**************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>administrators works!</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/accounting/accounting.component.html":
/*!**************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/accounting/accounting.component.html ***!
  \**************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>accounting works!</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/administrators/administrators.component.html":
/*!**********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/administrators/administrators.component.html ***!
  \**********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>administrators works!</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/developers/developers.component.html":
/*!**************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/developers/developers.component.html ***!
  \**************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>developers works!</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/directors/directors.component.html":
/*!************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/directors/directors.component.html ***!
  \************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>directors works!</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/engineers/engineers.component.html":
/*!************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/engineers/engineers.component.html ***!
  \************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>engineers works!</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/home/home.component.html":
/*!**************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/home/home.component.html ***!
  \**************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>home works!</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/login/login.component.html":
/*!****************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/login/login.component.html ***!
  \****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div fxFill fxLayout=\"column\" fxLayoutAlign=\"center center\">\r\n  <div\r\n    *ngIf=\"auth.user | async as user; else login\"\r\n    fxLayout=\"row\"\r\n    fxLayoutAlign=\"center center\"\r\n    fxLayoutGap=\"10px\"\r\n  >\r\n    <button color=\"accent\" mat-raised-button (click)=\"auth.signOut()\">\r\n      SIGN-OUT\r\n    </button>\r\n    <button color=\"primary\" mat-raised-button routerLink=\"\">\r\n      Home\r\n    </button>\r\n  </div>\r\n  <ng-template #login>\r\n    <button color=\"accent\" mat-raised-button (click)=\"auth.googleSignin()\">\r\n      SIGN-IN\r\n    </button>\r\n  </ng-template>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/not-found/not-found.component.html":
/*!************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/not-found/not-found.component.html ***!
  \************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>not-found works!</p>\r\n");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _modules_signage_components_signage_slider_signage_slider_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modules/signage/components/signage-slider/signage-slider.component */ "./src/app/modules/signage/components/signage-slider/signage-slider.component.ts");
/* harmony import */ var _guards_auth_guard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./guards/auth.guard */ "./src/app/guards/auth.guard.ts");
/* harmony import */ var _pages_login_login_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./pages/login/login.component */ "./src/app/pages/login/login.component.ts");
/* harmony import */ var _pages_not_found_not_found_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./pages/not-found/not-found.component */ "./src/app/pages/not-found/not-found.component.ts");







const routes = [
    { path: 'login', component: _pages_login_login_component__WEBPACK_IMPORTED_MODULE_5__["LoginComponent"], pathMatch: 'full' },
    { path: '404', component: _pages_not_found_not_found_component__WEBPACK_IMPORTED_MODULE_6__["NotFoundComponent"], pathMatch: 'full' },
    {
        path: '',
        component: _modules_signage_components_signage_slider_signage_slider_component__WEBPACK_IMPORTED_MODULE_3__["SignageSliderComponent"],
        canActivate: [_guards_auth_guard__WEBPACK_IMPORTED_MODULE_4__["AuthGuard"]],
        pathMatch: 'full'
    },
    { path: '**', redirectTo: '404' }
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes)],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.scss":
/*!************************************!*\
  !*** ./src/app/app.component.scss ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2FwcC5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_service_worker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/service-worker */ "./node_modules/@angular/service-worker/fesm2015/service-worker.js");



let AppComponent = class AppComponent {
    constructor(updates) {
        this.updates = updates;
        this.title = "digital-signage";
    }
    ngOnInit() {
        setInterval(() => {
            console.log("checking for updates on interval");
            this.updates.available.subscribe(event => {
                console.log("in updates.available.subscribe");
                this.updates.activateUpdate().then(() => document.location.reload());
            });
        }, 60000);
    }
};
AppComponent.ctorParameters = () => [
    { type: _angular_service_worker__WEBPACK_IMPORTED_MODULE_2__["SwUpdate"] }
];
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-root",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.scss */ "./src/app/app.component.scss")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var angularfire2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! angularfire2 */ "./node_modules/angularfire2/index.js");
/* harmony import */ var angularfire2__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(angularfire2__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var angularfire2_firestore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! angularfire2/firestore */ "./node_modules/angularfire2/firestore/index.js");
/* harmony import */ var angularfire2_firestore__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(angularfire2_firestore__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _pages_home_home_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./pages/home/home.component */ "./src/app/pages/home/home.component.ts");
/* harmony import */ var _pages_login_login_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./pages/login/login.component */ "./src/app/pages/login/login.component.ts");
/* harmony import */ var _pages_accounting_accounting_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./pages/accounting/accounting.component */ "./src/app/pages/accounting/accounting.component.ts");
/* harmony import */ var _pages_administrators_administrators_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./pages/administrators/administrators.component */ "./src/app/pages/administrators/administrators.component.ts");
/* harmony import */ var _pages_directors_directors_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./pages/directors/directors.component */ "./src/app/pages/directors/directors.component.ts");
/* harmony import */ var _pages_developers_developers_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./pages/developers/developers.component */ "./src/app/pages/developers/developers.component.ts");
/* harmony import */ var _pages_engineers_engineers_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./pages/engineers/engineers.component */ "./src/app/pages/engineers/engineers.component.ts");
/* harmony import */ var _components_signage_card_signage_card_component__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./components/signage-card/signage-card.component */ "./src/app/components/signage-card/signage-card.component.ts");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _modules_signage_signage_module__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./modules/signage/signage.module */ "./src/app/modules/signage/signage.module.ts");
/* harmony import */ var _modules_signage_services_http_service__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./modules/signage/services/http.service */ "./src/app/modules/signage/services/http.service.ts");
/* harmony import */ var _services_auth_service__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./services/auth.service */ "./src/app/services/auth.service.ts");
/* harmony import */ var _angular_fire_auth__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @angular/fire/auth */ "./node_modules/@angular/fire/auth/es2015/index.js");
/* harmony import */ var _pages_not_found_not_found_component__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./pages/not-found/not-found.component */ "./src/app/pages/not-found/not-found.component.ts");
/* harmony import */ var _modules_shared_shared_module__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./modules/shared/shared.module */ "./src/app/modules/shared/shared.module.ts");
/* harmony import */ var _angular_service_worker__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @angular/service-worker */ "./node_modules/@angular/service-worker/fesm2015/service-worker.js");
























let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_7__["AppComponent"],
            _pages_home_home_component__WEBPACK_IMPORTED_MODULE_8__["HomeComponent"],
            _pages_login_login_component__WEBPACK_IMPORTED_MODULE_9__["LoginComponent"],
            _pages_accounting_accounting_component__WEBPACK_IMPORTED_MODULE_10__["AccountingComponent"],
            _pages_administrators_administrators_component__WEBPACK_IMPORTED_MODULE_11__["AdministratorsComponent"],
            _pages_directors_directors_component__WEBPACK_IMPORTED_MODULE_12__["DirectorsComponent"],
            _pages_developers_developers_component__WEBPACK_IMPORTED_MODULE_13__["DevelopersComponent"],
            _pages_engineers_engineers_component__WEBPACK_IMPORTED_MODULE_14__["EngineersComponent"],
            _components_signage_card_signage_card_component__WEBPACK_IMPORTED_MODULE_15__["SignageCardComponent"],
            _pages_not_found_not_found_component__WEBPACK_IMPORTED_MODULE_21__["NotFoundComponent"]
        ],
        imports: [
            _modules_signage_signage_module__WEBPACK_IMPORTED_MODULE_17__["SignageModule"],
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _angular_fire_auth__WEBPACK_IMPORTED_MODULE_20__["AngularFireAuthModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_6__["AppRoutingModule"],
            _modules_shared_shared_module__WEBPACK_IMPORTED_MODULE_22__["SharedModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_16__["NoopAnimationsModule"],
            angularfire2__WEBPACK_IMPORTED_MODULE_4__["AngularFireModule"].initializeApp(_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].firebase),
            angularfire2_firestore__WEBPACK_IMPORTED_MODULE_5__["AngularFirestoreModule"],
            _angular_service_worker__WEBPACK_IMPORTED_MODULE_23__["ServiceWorkerModule"].register('ngsw-worker.js', { enabled: _environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].production })
        ],
        providers: [_modules_signage_services_http_service__WEBPACK_IMPORTED_MODULE_18__["HttpService"], _services_auth_service__WEBPACK_IMPORTED_MODULE_19__["AuthService"]],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_7__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/components/signage-card/signage-card.component.scss":
/*!*********************************************************************!*\
  !*** ./src/app/components/signage-card/signage-card.component.scss ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvc2lnbmFnZS1jYXJkL3NpZ25hZ2UtY2FyZC5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/components/signage-card/signage-card.component.ts":
/*!*******************************************************************!*\
  !*** ./src/app/components/signage-card/signage-card.component.ts ***!
  \*******************************************************************/
/*! exports provided: SignageCardComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SignageCardComponent", function() { return SignageCardComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let SignageCardComponent = class SignageCardComponent {
    constructor() { }
    ngOnInit() {
    }
};
SignageCardComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-signage-card',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./signage-card.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/signage-card/signage-card.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./signage-card.component.scss */ "./src/app/components/signage-card/signage-card.component.scss")).default]
    })
], SignageCardComponent);



/***/ }),

/***/ "./src/app/guards/auth.guard.ts":
/*!**************************************!*\
  !*** ./src/app/guards/auth.guard.ts ***!
  \**************************************/
/*! exports provided: AuthGuard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthGuard", function() { return AuthGuard; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _services_auth_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../services/auth.service */ "./src/app/services/auth.service.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");





let AuthGuard = class AuthGuard {
    constructor(router, auth) {
        this.router = router;
        this.auth = auth;
    }
    canActivate(next, state) {
        return this.auth.user.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["take"])(1), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(user => !!user), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["tap"])(loggedIn => {
            if (!loggedIn) {
                this.router.navigate(['/login']);
            }
        }));
    }
    canLoad(route, segments) {
        return this.auth.user.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["take"])(1), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(user => !!user), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["tap"])(loggedIn => {
            if (!loggedIn) {
                this.router.navigate(['/login']);
            }
        }));
    }
};
AuthGuard.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _services_auth_service__WEBPACK_IMPORTED_MODULE_3__["AuthService"] }
];
AuthGuard = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], AuthGuard);



/***/ }),

/***/ "./src/app/modules/shared/custom-breakpoint.ts":
/*!*****************************************************!*\
  !*** ./src/app/modules/shared/custom-breakpoint.ts ***!
  \*****************************************************/
/*! exports provided: CUSTOM_BREAKPOINTS */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CUSTOM_BREAKPOINTS", function() { return CUSTOM_BREAKPOINTS; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

const CUSTOM_BREAKPOINTS = [
    {
        alias: "xs",
        suffix: "xs",
        mediaQuery: "screen and (max-width: 599px)",
        overlapping: false,
        priority: 1000
    },
    {
        alias: "sm",
        suffix: "sm",
        mediaQuery: "screen and (min-width: 600px) and (max-width: 959px)",
        overlapping: false,
        priority: 900
    },
    {
        alias: "md",
        suffix: "md",
        mediaQuery: "screen and (min-width: 960px) and (max-width: 1449px)",
        overlapping: false,
        priority: 800
    },
    {
        alias: "lg",
        suffix: "lg",
        mediaQuery: "screen and (min-width: 1450px) and (max-width: 1679px)",
        overlapping: false,
        priority: 700
    },
    {
        alias: "xl",
        suffix: "xl",
        mediaQuery: "screen and (min-width: 1680px)",
        overlapping: false,
        priority: 600
    },
    {
        alias: "gt-xs",
        suffix: "gt-xs",
        mediaQuery: "screen and (min-width: 600px)",
        overlapping: true,
        priority: -900
    },
    {
        alias: "gt-sm",
        suffix: "gt-sm",
        mediaQuery: "screen and (min-width: 960px)",
        overlapping: true,
        priority: -800
    },
    {
        alias: "gt-md",
        suffix: "gt-md",
        mediaQuery: "screen and (min-width: 1450px)",
        overlapping: true,
        priority: -700
    },
    {
        alias: "gt-lg",
        suffix: "gt-lg",
        mediaQuery: "screen and (min-width: 1680px)",
        overlapping: true,
        priority: -600
    },
    {
        alias: "lt-sm",
        suffix: "lt-sm",
        mediaQuery: "screen and (max-width: 599px)",
        overlapping: true,
        priority: 950
    },
    {
        alias: "lt-md",
        suffix: "lt-md",
        mediaQuery: "screen and (max-width: 959px)",
        overlapping: true,
        priority: 850
    },
    {
        alias: "lt-lg",
        suffix: "lt-lg",
        mediaQuery: "screen and (max-width: 1449px)",
        overlapping: true,
        priority: 750
    },
    {
        alias: "lt-xl",
        suffix: "lt-xl",
        mediaQuery: "screen and (max-width: 1679px)",
        overlapping: true,
        priority: 650
    }
];


/***/ }),

/***/ "./src/app/modules/shared/shared.module.ts":
/*!*************************************************!*\
  !*** ./src/app/modules/shared/shared.module.ts ***!
  \*************************************************/
/*! exports provided: SharedModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SharedModule", function() { return SharedModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_flex_layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/flex-layout */ "./node_modules/@angular/flex-layout/esm2015/flex-layout.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _custom_breakpoint__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./custom-breakpoint */ "./src/app/modules/shared/custom-breakpoint.ts");








let SharedModule = class SharedModule {
};
SharedModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_5__["CommonModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatProgressBarModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatRippleModule"],
            _angular_flex_layout__WEBPACK_IMPORTED_MODULE_4__["FlexLayoutModule"].withConfig({ mediaTriggerAutoRestore: true }, _custom_breakpoint__WEBPACK_IMPORTED_MODULE_7__["CUSTOM_BREAKPOINTS"])
        ],
        exports: [
            _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormsModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_3__["ReactiveFormsModule"],
            _angular_flex_layout__WEBPACK_IMPORTED_MODULE_4__["FlexLayoutModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatButtonModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatMenuModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatCardModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatGridListModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatDialogModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatBadgeModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatSnackBarModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatToolbarModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatSidenavModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatProgressBarModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatInputModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatFormFieldModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatTooltipModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatExpansionModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatCheckboxModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatChipsModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatTableModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatPaginatorModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatSortModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatStepperModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatOptionModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatSelectModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatButtonToggleModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatSlideToggleModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatAutocompleteModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatDatepickerModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatNativeDateModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_6__["HttpClientModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatRippleModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatProgressSpinnerModule"]
        ]
    })
], SharedModule);



/***/ }),

/***/ "./src/app/modules/signage/components/booking-values-per-engineer/booking-values-per-engineer.component.scss":
/*!*******************************************************************************************************************!*\
  !*** ./src/app/modules/signage/components/booking-values-per-engineer/booking-values-per-engineer.component.scss ***!
  \*******************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".timestamp {\n  text-align: center;\n  font-size: 1.4rem;\n  font-weight: 400;\n  max-height: 40px;\n  width: 33%;\n  position: absolute;\n  top: 6%;\n}\n\n.legend {\n  width: 100%;\n  margin-top: 110px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvbW9kdWxlcy9zaWduYWdlL2NvbXBvbmVudHMvYm9va2luZy12YWx1ZXMtcGVyLWVuZ2luZWVyL0M6XFxVc2Vyc1xcUmljaGFyZFxcRG9jdW1lbnRzXFxfMDBkaWdpdGFsLXNpZ25hZ2VcXGRpZ2l0YWwtc2lnbmFnZS9zcmNcXGFwcFxcbW9kdWxlc1xcc2lnbmFnZVxcY29tcG9uZW50c1xcYm9va2luZy12YWx1ZXMtcGVyLWVuZ2luZWVyXFxib29raW5nLXZhbHVlcy1wZXItZW5naW5lZXIuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL21vZHVsZXMvc2lnbmFnZS9jb21wb25lbnRzL2Jvb2tpbmctdmFsdWVzLXBlci1lbmdpbmVlci9ib29raW5nLXZhbHVlcy1wZXItZW5naW5lZXIuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxrQkFBQTtFQUNBLGlCQUFBO0VBQ0EsZ0JBQUE7RUFDQSxnQkFBQTtFQUNBLFVBQUE7RUFDQSxrQkFBQTtFQUNBLE9BQUE7QUNDRjs7QURFQTtFQUNFLFdBQUE7RUFDQSxpQkFBQTtBQ0NGIiwiZmlsZSI6InNyYy9hcHAvbW9kdWxlcy9zaWduYWdlL2NvbXBvbmVudHMvYm9va2luZy12YWx1ZXMtcGVyLWVuZ2luZWVyL2Jvb2tpbmctdmFsdWVzLXBlci1lbmdpbmVlci5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi50aW1lc3RhbXAge1xyXG4gIHRleHQtYWxpZ246IGNlbnRlcjtcclxuICBmb250LXNpemU6IDEuNHJlbTtcclxuICBmb250LXdlaWdodDogNDAwO1xyXG4gIG1heC1oZWlnaHQ6IDQwcHg7XHJcbiAgd2lkdGg6IDMzJTtcclxuICBwb3NpdGlvbjogYWJzb2x1dGU7XHJcbiAgdG9wOiA2JTtcclxufVxyXG5cclxuLmxlZ2VuZCB7XHJcbiAgd2lkdGg6IDEwMCU7XHJcbiAgbWFyZ2luLXRvcDogMTEwcHg7XHJcbn1cclxuIiwiLnRpbWVzdGFtcCB7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgZm9udC1zaXplOiAxLjRyZW07XG4gIGZvbnQtd2VpZ2h0OiA0MDA7XG4gIG1heC1oZWlnaHQ6IDQwcHg7XG4gIHdpZHRoOiAzMyU7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiA2JTtcbn1cblxuLmxlZ2VuZCB7XG4gIHdpZHRoOiAxMDAlO1xuICBtYXJnaW4tdG9wOiAxMTBweDtcbn0iXX0= */");

/***/ }),

/***/ "./src/app/modules/signage/components/booking-values-per-engineer/booking-values-per-engineer.component.ts":
/*!*****************************************************************************************************************!*\
  !*** ./src/app/modules/signage/components/booking-values-per-engineer/booking-values-per-engineer.component.ts ***!
  \*****************************************************************************************************************/
/*! exports provided: BookingValuesPerEngineerComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BookingValuesPerEngineerComponent", function() { return BookingValuesPerEngineerComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_http_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../services/http.service */ "./src/app/modules/signage/services/http.service.ts");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);




let BookingValuesPerEngineerComponent = class BookingValuesPerEngineerComponent {
    constructor(dataService) {
        this.dataService = dataService;
        this.maxValue = 0;
        this.columnWidth = 0;
        this.topOfRed = 250;
        this.bottomOfYellow = 450;
        this.topOfYellow = 800;
        this.bottomOfGreen = 1000;
        this.colourScheme = {
            domain: [
                "#B9418E",
                "#42DAD0",
                "#E5DCEF",
                "#DF5331",
                "#E0C69E",
                "#F2BA3D",
                "#FF1A47",
                "#93F0A6",
                "#07ABF2",
                "#BF2327"
            ]
        };
        this.activeData = [];
        this.getScreenSize();
    }
    getScreenSize(event) {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
        if (this.screenWidth < 1450) {
            this.chartHeight = this.screenHeight * 0.45;
        }
        else if (this.screenWidth < 1680) {
            this.chartHeight = this.screenHeight * 0.6;
        }
        else {
            this.chartHeight = this.screenHeight * 0.65;
        }
        this.chartWidth = this.screenWidth * 0.9;
        this.setColumnWidth();
    }
    ngOnInit() {
        this.getBookingsData();
    }
    ngOnChanges() {
        this.getScreenSize();
        this.pageNumber = parseInt(this.page.split(" ")[1]);
        this.getBookingsData();
    }
    getBookingsData() {
        if (this.bookingsDataSubscription) {
            this.bookingsDataSubscription.unsubscribe();
        }
        this.bookingsDataSubscription = this.dataService
            .getFromFirestore("Engineer", "bookingValuesPer")
            .subscribe(result => {
            this.activeData = [];
            this.bookingsData = result[0].data;
            this.bookingsData = this.bookingsData.slice(10 * (this.pageNumber - 1), 10 * this.pageNumber);
            this.bookingsData[0].data.forEach(day => {
                this.activeData.push({
                    name: day.date
                });
            });
            this.maxValue = 0;
            this.getMaxValue();
            this.timestamp = result[0].lastUpdated;
            this.timeString = this.setTimeString();
            this.setColumnWidth();
        });
    }
    getMaxValue() {
        if (this.bookingsData) {
            this.bookingsData.forEach(person => {
                person.data.forEach(date => {
                    this.maxValue = Math.max(this.maxValue, date.value);
                });
            });
        }
    }
    setTimeString() {
        let string = "Last Updated ";
        const updatedMoment = moment__WEBPACK_IMPORTED_MODULE_3__["unix"](this.timestamp.seconds);
        string += updatedMoment.format("DD/MM - HH:mm");
        return string;
    }
    setColumnWidth() {
        if (this.bookingsData && this.chartWidth) {
            this.columnWidth = (this.chartWidth - 40) / this.bookingsData.length;
        }
    }
};
BookingValuesPerEngineerComponent.ctorParameters = () => [
    { type: _services_http_service__WEBPACK_IMPORTED_MODULE_2__["HttpService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], BookingValuesPerEngineerComponent.prototype, "page", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["HostListener"])("window:resize", ["$event"])
], BookingValuesPerEngineerComponent.prototype, "getScreenSize", null);
BookingValuesPerEngineerComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-booking-values-per-engineer",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./booking-values-per-engineer.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/booking-values-per-engineer/booking-values-per-engineer.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./booking-values-per-engineer.component.scss */ "./src/app/modules/signage/components/booking-values-per-engineer/booking-values-per-engineer.component.scss")).default]
    })
], BookingValuesPerEngineerComponent);



/***/ }),

/***/ "./src/app/modules/signage/components/custom-guage-chart/custom-guage-chart.component.scss":
/*!*************************************************************************************************!*\
  !*** ./src/app/modules/signage/components/custom-guage-chart/custom-guage-chart.component.scss ***!
  \*************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".gauge .background-arc path {\n  fill: rgba(0, 0, 0, 0.05);\n}\n.gauge .gauge-tick path {\n  stroke: #666;\n}\n.gauge .gauge-tick text {\n  font-size: 12px;\n  fill: #666;\n  font-weight: bold;\n}\n.gauge .gauge-tick-large path {\n  stroke-width: 2px;\n}\n.gauge .gauge-tick-small path {\n  stroke-width: 1px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvbW9kdWxlcy9zaWduYWdlL2NvbXBvbmVudHMvY3VzdG9tLWd1YWdlLWNoYXJ0L0M6XFxVc2Vyc1xcUmljaGFyZFxcRG9jdW1lbnRzXFxfMDBkaWdpdGFsLXNpZ25hZ2VcXGRpZ2l0YWwtc2lnbmFnZS9zcmNcXGFwcFxcbW9kdWxlc1xcc2lnbmFnZVxcY29tcG9uZW50c1xcY3VzdG9tLWd1YWdlLWNoYXJ0XFxjdXN0b20tZ3VhZ2UtY2hhcnQuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL21vZHVsZXMvc2lnbmFnZS9jb21wb25lbnRzL2N1c3RvbS1ndWFnZS1jaGFydC9jdXN0b20tZ3VhZ2UtY2hhcnQuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUk7RUFDRSx5QkFBQTtBQ0ROO0FETUk7RUFDRSxZQUFBO0FDSk47QURPSTtFQUNFLGVBQUE7RUFDQSxVQUFBO0VBQ0EsaUJBQUE7QUNMTjtBRFNFO0VBQ0UsaUJBQUE7QUNQSjtBRFVFO0VBQ0UsaUJBQUE7QUNSSiIsImZpbGUiOiJzcmMvYXBwL21vZHVsZXMvc2lnbmFnZS9jb21wb25lbnRzL2N1c3RvbS1ndWFnZS1jaGFydC9jdXN0b20tZ3VhZ2UtY2hhcnQuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuZ2F1Z2Uge1xyXG4gIC5iYWNrZ3JvdW5kLWFyYyB7XHJcbiAgICBwYXRoIHtcclxuICAgICAgZmlsbDogcmdiYSgwLCAwLCAwLCAwLjA1KTtcclxuICAgIH1cclxuICB9XHJcblxyXG4gIC5nYXVnZS10aWNrIHtcclxuICAgIHBhdGgge1xyXG4gICAgICBzdHJva2U6ICM2NjY7XHJcbiAgICB9XHJcblxyXG4gICAgdGV4dCB7XHJcbiAgICAgIGZvbnQtc2l6ZTogMTJweDtcclxuICAgICAgZmlsbDogIzY2NjtcclxuICAgICAgZm9udC13ZWlnaHQ6IGJvbGQ7XHJcbiAgICB9XHJcbiAgfVxyXG5cclxuICAuZ2F1Z2UtdGljay1sYXJnZSBwYXRoIHtcclxuICAgIHN0cm9rZS13aWR0aDogMnB4O1xyXG4gIH1cclxuXHJcbiAgLmdhdWdlLXRpY2stc21hbGwgcGF0aCB7XHJcbiAgICBzdHJva2Utd2lkdGg6IDFweDtcclxuICB9XHJcbn1cclxuIiwiLmdhdWdlIC5iYWNrZ3JvdW5kLWFyYyBwYXRoIHtcbiAgZmlsbDogcmdiYSgwLCAwLCAwLCAwLjA1KTtcbn1cbi5nYXVnZSAuZ2F1Z2UtdGljayBwYXRoIHtcbiAgc3Ryb2tlOiAjNjY2O1xufVxuLmdhdWdlIC5nYXVnZS10aWNrIHRleHQge1xuICBmb250LXNpemU6IDEycHg7XG4gIGZpbGw6ICM2NjY7XG4gIGZvbnQtd2VpZ2h0OiBib2xkO1xufVxuLmdhdWdlIC5nYXVnZS10aWNrLWxhcmdlIHBhdGgge1xuICBzdHJva2Utd2lkdGg6IDJweDtcbn1cbi5nYXVnZSAuZ2F1Z2UtdGljay1zbWFsbCBwYXRoIHtcbiAgc3Ryb2tlLXdpZHRoOiAxcHg7XG59Il19 */");

/***/ }),

/***/ "./src/app/modules/signage/components/custom-guage-chart/custom-guage-chart.component.ts":
/*!***********************************************************************************************!*\
  !*** ./src/app/modules/signage/components/custom-guage-chart/custom-guage-chart.component.ts ***!
  \***********************************************************************************************/
/*! exports provided: CustomGuageChartComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomGuageChartComponent", function() { return CustomGuageChartComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var d3_scale__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! d3-scale */ "./node_modules/d3-scale/index.js");
/* harmony import */ var _swimlane_ngx_charts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @swimlane/ngx-charts */ "./node_modules/@swimlane/ngx-charts/release/esm.js");




let CustomGuageChartComponent = class CustomGuageChartComponent extends _swimlane_ngx_charts__WEBPACK_IMPORTED_MODULE_3__["BaseChartComponent"] {
    constructor() {
        super(...arguments);
        this.legend = false;
        this.legendTitle = "Legend";
        this.legendPosition = "right";
        this.min = 0;
        this.max = 100;
        this.bigSegments = 10;
        this.smallSegments = 5;
        this.showAxis = true;
        this.startAngle = -120;
        this.angleSpan = 240;
        this.activeEntries = [];
        this.tooltipDisabled = false;
        this.showText = true;
        this.activate = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.deactivate = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.resizeScale = 1;
        this.rotation = "";
        this.textTransform = "scale(1, 1)";
        this.cornerRadius = 10;
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        setTimeout(() => this.scaleText());
    }
    update() {
        super.update();
        if (!this.showAxis) {
            if (!this.margin) {
                this.margin = [10, 20, 10, 20];
            }
        }
        else {
            if (!this.margin) {
                this.margin = [60, 100, 60, 100];
            }
        }
        // make the starting angle positive
        if (this.startAngle < 0) {
            this.startAngle = (this.startAngle % 360) + 360;
        }
        this.angleSpan = Math.min(this.angleSpan, 360);
        this.dims = Object(_swimlane_ngx_charts__WEBPACK_IMPORTED_MODULE_3__["calculateViewDimensions"])({
            width: this.width,
            height: this.height,
            margins: this.margin,
            showLegend: this.legend,
            legendPosition: this.legendPosition
        });
        this.domain = this.getDomain();
        this.valueDomain = this.getValueDomain();
        this.valueScale = this.getValueScale();
        this.displayValue = this.getDisplayValue();
        this.outerRadius = Math.min(this.dims.width, this.dims.height) / 2;
        this.arcs = this.getArcs();
        this.setColors();
        this.legendOptions = this.getLegendOptions();
        const xOffset = this.margin[3] + this.dims.width / 2;
        const yOffset = this.margin[0] + this.dims.height / 2;
        this.transform = `translate(${xOffset}, ${yOffset})`;
        this.rotation = `rotate(${this.startAngle})`;
        setTimeout(() => this.scaleText(), 50);
    }
    getArcs() {
        const arcs = [];
        //the last number on this line             \/
        const availableRadius = this.outerRadius * 0.6;
        //and this line, this one is more important                          \/
        const radiusPerArc = Math.min(availableRadius / this.results.length, 25);
        const arcWidth = radiusPerArc * 0.7;
        this.textRadius = Math.min(this.outerRadius - this.results.length * radiusPerArc, this.outerRadius * 0.5);
        this.cornerRadius = Math.floor(arcWidth / 2);
        let i = 0;
        for (const d of this.results) {
            const outerRadius = this.outerRadius - i * radiusPerArc;
            const innerRadius = outerRadius - arcWidth;
            const backgroundArc = {
                endAngle: (this.angleSpan * Math.PI) / 180,
                innerRadius,
                outerRadius,
                data: {
                    value: this.max,
                    name: d.name
                }
            };
            const valueArc = {
                endAngle: (Math.min(this.valueScale(d.value), this.angleSpan) * Math.PI) / 180,
                innerRadius,
                outerRadius,
                data: {
                    value: d.value,
                    name: d.name
                }
            };
            const arc = {
                backgroundArc,
                valueArc
            };
            arcs.push(arc);
            i++;
        }
        return arcs;
    }
    getDomain() {
        return this.results.map(d => d.name);
    }
    getValueDomain() {
        const values = this.results.map(d => d.value);
        const dataMin = Math.min(...values);
        const dataMax = Math.max(...values);
        if (this.min !== undefined) {
            this.min = Math.min(this.min, dataMin);
        }
        else {
            this.min = dataMin;
        }
        if (this.max !== undefined) {
            this.max = Math.max(this.max, dataMax);
        }
        else {
            this.max = dataMax;
        }
        return [this.min, this.max];
    }
    getValueScale() {
        return Object(d3_scale__WEBPACK_IMPORTED_MODULE_2__["scaleLinear"])()
            .range([0, this.angleSpan])
            .nice()
            .domain(this.valueDomain);
    }
    getDisplayValue() {
        const value = this.results.map(d => d.value).reduce((a, b) => a + b, 0);
        if (this.textValue && 0 !== this.textValue.length) {
            return this.textValue.toLocaleString();
        }
        if (this.valueFormatting) {
            return this.valueFormatting(value);
        }
        return value.toLocaleString();
    }
    scaleText(repeat = true) {
        if (!this.showText || !(this.textTransform === "scale(1, 1)")) {
            return;
        }
        const { width } = this.textEl.nativeElement.getBoundingClientRect();
        const oldScale = this.resizeScale;
        if (width === 0) {
            this.resizeScale = 1;
        }
        else {
            const availableSpace = this.textRadius;
            this.resizeScale =
                Math.floor((availableSpace / (width / this.resizeScale)) * 100) / 100;
        }
        if (this.resizeScale !== oldScale) {
            this.textTransform = `scale(${this.resizeScale}, ${this.resizeScale})`;
            this.cd.markForCheck();
            if (repeat) {
                setTimeout(() => this.scaleText(false), 50);
            }
        }
    }
    onClick(data) {
        this.select.emit(data);
    }
    getLegendOptions() {
        return {
            scaleType: "ordinal",
            colors: this.colors,
            domain: this.domain,
            title: this.legendTitle,
            position: this.legendPosition
        };
    }
    setColors() {
        this.colors = new _swimlane_ngx_charts__WEBPACK_IMPORTED_MODULE_3__["ColorHelper"](this.scheme, "ordinal", this.domain, this.customColors);
    }
    onActivate(item) {
        const idx = this.activeEntries.findIndex(d => {
            return d.name === item.name && d.value === item.value;
        });
        if (idx > -1) {
            return;
        }
        this.activeEntries = [item, ...this.activeEntries];
        this.activate.emit({ value: item, entries: this.activeEntries });
    }
    onDeactivate(item) {
        const idx = this.activeEntries.findIndex(d => {
            return d.name === item.name && d.value === item.value;
        });
        this.activeEntries.splice(idx, 1);
        this.activeEntries = [...this.activeEntries];
        this.deactivate.emit({ value: item, entries: this.activeEntries });
    }
    isActive(entry) {
        if (!this.activeEntries)
            return false;
        const item = this.activeEntries.find(d => {
            return entry.name === d.name && entry.series === d.series;
        });
        return item !== undefined;
    }
    trackBy(index, item) {
        return item.valueArc.data.name;
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomGuageChartComponent.prototype, "legend", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomGuageChartComponent.prototype, "legendTitle", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomGuageChartComponent.prototype, "legendPosition", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomGuageChartComponent.prototype, "min", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomGuageChartComponent.prototype, "max", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomGuageChartComponent.prototype, "textValue", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomGuageChartComponent.prototype, "units", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomGuageChartComponent.prototype, "bigSegments", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomGuageChartComponent.prototype, "smallSegments", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomGuageChartComponent.prototype, "results", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomGuageChartComponent.prototype, "showAxis", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomGuageChartComponent.prototype, "startAngle", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomGuageChartComponent.prototype, "angleSpan", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomGuageChartComponent.prototype, "activeEntries", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomGuageChartComponent.prototype, "axisTickFormatting", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomGuageChartComponent.prototype, "tooltipDisabled", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomGuageChartComponent.prototype, "valueFormatting", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomGuageChartComponent.prototype, "showText", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomGuageChartComponent.prototype, "margin", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], CustomGuageChartComponent.prototype, "activate", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], CustomGuageChartComponent.prototype, "deactivate", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ContentChild"])("tooltipTemplate", { static: false })
], CustomGuageChartComponent.prototype, "tooltipTemplate", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])("textEl", { static: false })
], CustomGuageChartComponent.prototype, "textEl", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomGuageChartComponent.prototype, "textTransform", void 0);
CustomGuageChartComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-custom-guage-chart",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./custom-guage-chart.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/custom-guage-chart/custom-guage-chart.component.html")).default,
        encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
        changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectionStrategy"].OnPush,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./custom-guage-chart.component.scss */ "./src/app/modules/signage/components/custom-guage-chart/custom-guage-chart.component.scss")).default]
    })
], CustomGuageChartComponent);



/***/ }),

/***/ "./src/app/modules/signage/components/custom-legend/custom-legend.component.scss":
/*!***************************************************************************************!*\
  !*** ./src/app/modules/signage/components/custom-legend/custom-legend.component.scss ***!
  \***************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".legend {\n  width: 95%;\n  position: relative;\n  border-radius: 5px;\n  margin: 0 auto;\n}\n\n.body {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n}\n\n.legendItem {\n  flex-basis: 17%;\n  display: flex;\n}\n\n.tag {\n  margin-left: 5px;\n  font-size: 1.3rem;\n  position: relative;\n  bottom: 4px;\n}\n\n.bold {\n  font-weight: 700;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvbW9kdWxlcy9zaWduYWdlL2NvbXBvbmVudHMvY3VzdG9tLWxlZ2VuZC9DOlxcVXNlcnNcXFJpY2hhcmRcXERvY3VtZW50c1xcXzAwZGlnaXRhbC1zaWduYWdlXFxkaWdpdGFsLXNpZ25hZ2Uvc3JjXFxhcHBcXG1vZHVsZXNcXHNpZ25hZ2VcXGNvbXBvbmVudHNcXGN1c3RvbS1sZWdlbmRcXGN1c3RvbS1sZWdlbmQuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL21vZHVsZXMvc2lnbmFnZS9jb21wb25lbnRzL2N1c3RvbS1sZWdlbmQvY3VzdG9tLWxlZ2VuZC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLFVBQUE7RUFDQSxrQkFBQTtFQUNBLGtCQUFBO0VBQ0EsY0FBQTtBQ0NGOztBREVBO0VBQ0Usa0JBQUE7RUFDQSxhQUFBO0VBQ0EsZUFBQTtFQUNBLDZCQUFBO0FDQ0Y7O0FERUE7RUFDRSxlQUFBO0VBQ0EsYUFBQTtBQ0NGOztBREVBO0VBQ0UsZ0JBQUE7RUFDQSxpQkFBQTtFQUNBLGtCQUFBO0VBQ0EsV0FBQTtBQ0NGOztBREVBO0VBQ0UsZ0JBQUE7QUNDRiIsImZpbGUiOiJzcmMvYXBwL21vZHVsZXMvc2lnbmFnZS9jb21wb25lbnRzL2N1c3RvbS1sZWdlbmQvY3VzdG9tLWxlZ2VuZC5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5sZWdlbmQge1xyXG4gIHdpZHRoOiA5NSU7XHJcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xyXG4gIGJvcmRlci1yYWRpdXM6IDVweDtcclxuICBtYXJnaW46IDAgYXV0bztcclxufVxyXG5cclxuLmJvZHkge1xyXG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcclxuICBkaXNwbGF5OiBmbGV4O1xyXG4gIGZsZXgtd3JhcDogd3JhcDtcclxuICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWFyb3VuZDtcclxufVxyXG5cclxuLmxlZ2VuZEl0ZW0ge1xyXG4gIGZsZXgtYmFzaXM6IDE3JTtcclxuICBkaXNwbGF5OiBmbGV4O1xyXG59XHJcblxyXG4udGFnIHtcclxuICBtYXJnaW4tbGVmdDogNXB4O1xyXG4gIGZvbnQtc2l6ZTogMS4zcmVtO1xyXG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcclxuICBib3R0b206IDRweDtcclxufVxyXG5cclxuLmJvbGQge1xyXG4gIGZvbnQtd2VpZ2h0OiA3MDA7XHJcbn1cclxuIiwiLmxlZ2VuZCB7XG4gIHdpZHRoOiA5NSU7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgYm9yZGVyLXJhZGl1czogNXB4O1xuICBtYXJnaW46IDAgYXV0bztcbn1cblxuLmJvZHkge1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtd3JhcDogd3JhcDtcbiAganVzdGlmeS1jb250ZW50OiBzcGFjZS1hcm91bmQ7XG59XG5cbi5sZWdlbmRJdGVtIHtcbiAgZmxleC1iYXNpczogMTclO1xuICBkaXNwbGF5OiBmbGV4O1xufVxuXG4udGFnIHtcbiAgbWFyZ2luLWxlZnQ6IDVweDtcbiAgZm9udC1zaXplOiAxLjNyZW07XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgYm90dG9tOiA0cHg7XG59XG5cbi5ib2xkIHtcbiAgZm9udC13ZWlnaHQ6IDcwMDtcbn0iXX0= */");

/***/ }),

/***/ "./src/app/modules/signage/components/custom-legend/custom-legend.component.ts":
/*!*************************************************************************************!*\
  !*** ./src/app/modules/signage/components/custom-legend/custom-legend.component.ts ***!
  \*************************************************************************************/
/*! exports provided: CustomLegendComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomLegendComponent", function() { return CustomLegendComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let CustomLegendComponent = class CustomLegendComponent {
    constructor() {
        this.colours = [];
        this.names = [];
        this.totalsDisplayed = false;
        this.totalsUnits = "";
    }
    ngOnInit() { }
    ngOnChanges() {
        this.names = [];
        this.colours = [];
        if (this.dataFormat === "multi") {
            if (this.customColours && this.customColours.length > 0) {
                for (let i = 0; i < this.customColours.length; i++) {
                    for (let j = 0, found = false; j < this.activeData[0].series.length && found === false; j++) {
                        if (this.activeData[0].series[j].name === this.customColours[i].name) {
                            found = true;
                            this.names.push(this.customColours[i].name);
                            this.colours.push(this.customColours[i].value);
                        }
                    }
                }
            }
            else if (this.scheme && this.scheme.length > 0) {
                for (let i = 0; i < this.activeData[0].series.length; i++) {
                    this.names.push(this.activeData[0].series[i].name);
                    this.colours.push(this.scheme[i % this.scheme.length]);
                }
            }
        }
        else if (this.dataFormat === "single") {
            if (this.customColours && this.customColours.length > 0) {
                for (let i = 0; i < this.customColours.length; i++) {
                    for (let j = 0, found = false; j < this.activeData.length && found === false; j++) {
                        if (this.activeData[j].name === this.customColours[i].name) {
                            found = true;
                            this.names.push(this.customColours[i].name);
                            this.colours.push(this.customColours[i].value);
                        }
                    }
                }
            }
            else if (this.scheme && this.scheme.domain.length > 0) {
                for (let i = 0; i < this.activeData.length; i++) {
                    this.names.push(this.activeData[i].name);
                    this.colours.push(this.scheme.domain[i % this.scheme.domain.length]);
                }
            }
        }
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomLegendComponent.prototype, "customColours", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomLegendComponent.prototype, "scheme", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomLegendComponent.prototype, "dataFormat", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomLegendComponent.prototype, "activeData", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomLegendComponent.prototype, "totalsDisplayed", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomLegendComponent.prototype, "totalsUnits", void 0);
CustomLegendComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-custom-legend",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./custom-legend.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/custom-legend/custom-legend.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./custom-legend.component.scss */ "./src/app/modules/signage/components/custom-legend/custom-legend.component.scss")).default]
    })
], CustomLegendComponent);



/***/ }),

/***/ "./src/app/modules/signage/components/custom-x-axis/custom-x-axis.component.scss":
/*!***************************************************************************************!*\
  !*** ./src/app/modules/signage/components/custom-x-axis/custom-x-axis.component.scss ***!
  \***************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".xAxis {\n  width: 100%;\n  position: relative;\n}\n\n.name {\n  text-align: end;\n  font-size: 1.5rem;\n  font-weight: 500;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvbW9kdWxlcy9zaWduYWdlL2NvbXBvbmVudHMvY3VzdG9tLXgtYXhpcy9DOlxcVXNlcnNcXFJpY2hhcmRcXERvY3VtZW50c1xcXzAwZGlnaXRhbC1zaWduYWdlXFxkaWdpdGFsLXNpZ25hZ2Uvc3JjXFxhcHBcXG1vZHVsZXNcXHNpZ25hZ2VcXGNvbXBvbmVudHNcXGN1c3RvbS14LWF4aXNcXGN1c3RvbS14LWF4aXMuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL21vZHVsZXMvc2lnbmFnZS9jb21wb25lbnRzL2N1c3RvbS14LWF4aXMvY3VzdG9tLXgtYXhpcy5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLFdBQUE7RUFDQSxrQkFBQTtBQ0NGOztBREVBO0VBQ0UsZUFBQTtFQUNBLGlCQUFBO0VBQ0EsZ0JBQUE7QUNDRiIsImZpbGUiOiJzcmMvYXBwL21vZHVsZXMvc2lnbmFnZS9jb21wb25lbnRzL2N1c3RvbS14LWF4aXMvY3VzdG9tLXgtYXhpcy5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi54QXhpcyB7XHJcbiAgd2lkdGg6IDEwMCU7XHJcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xyXG59XHJcblxyXG4ubmFtZSB7XHJcbiAgdGV4dC1hbGlnbjogZW5kO1xyXG4gIGZvbnQtc2l6ZTogMS41cmVtO1xyXG4gIGZvbnQtd2VpZ2h0OiA1MDA7XHJcbn1cclxuIiwiLnhBeGlzIHtcbiAgd2lkdGg6IDEwMCU7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbn1cblxuLm5hbWUge1xuICB0ZXh0LWFsaWduOiBlbmQ7XG4gIGZvbnQtc2l6ZTogMS41cmVtO1xuICBmb250LXdlaWdodDogNTAwO1xufSJdfQ== */");

/***/ }),

/***/ "./src/app/modules/signage/components/custom-x-axis/custom-x-axis.component.ts":
/*!*************************************************************************************!*\
  !*** ./src/app/modules/signage/components/custom-x-axis/custom-x-axis.component.ts ***!
  \*************************************************************************************/
/*! exports provided: CustomXAxisComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomXAxisComponent", function() { return CustomXAxisComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let CustomXAxisComponent = class CustomXAxisComponent {
    constructor() {
        this.showDataLabels = false;
        this.showTotals = false;
        this.labelFormat = "none";
    }
    ngOnInit() { }
    ngOnChanges() {
        this.namesLeft = (this.view[0] / 2 - 80).toString() + "px";
        this.barPaddingWidth = this.barPadding.toString() + "px";
        let calc = this.view[0];
        calc -= 50;
        calc -= this.barPadding * (this.names.length - 1);
        calc = calc / this.names.length;
        this.barWidth = calc.toString() + "px";
        let viewWidthNum = 0;
        if (this.view[0] < 816) {
            viewWidthNum = this.view[0] - calc - 15;
        }
        else {
            viewWidthNum = this.view[0] - calc + 20;
        }
        this.viewWidth = viewWidthNum.toString() + "px";
        this.namesTop = (this.view[1] + 75 - viewWidthNum / 2).toString() + "px";
        calc = calc / 2;
        this.halfNameWidth = calc.toString() + "px";
        if (this.showDataLabels && this.dataLabels) {
            this.processDataLabels();
        }
        if (this.showTotals && this.totals) {
            this.processTotals();
        }
    }
    processDataLabels() {
        if (this.dataType === "multi") {
            for (let i = 0; i < this.dataLabels.length; i++) {
                let total = 0;
                for (let j = 0; j < this.dataLabels[i].length; j++) {
                    const { name, value } = this.dataLabels[i][j];
                    let calc = total + value / 2;
                    calc = ((this.view[1] - 20) * calc) / this.maxValue;
                    this.dataLabels[i][j].barHeight =
                        ((this.view[1] - 20) * value) / this.maxValue;
                    if (this.view[0] < 816) {
                        calc += 3;
                    }
                    else {
                        calc -= 5;
                    }
                    this.dataLabels[i][j].height = calc.toString() + "px";
                    total += value;
                    if (this.labelFormat === "value") {
                        this.dataLabels[i][j].display = value.toString();
                    }
                    else if (this.labelFormat === "name") {
                        this.dataLabels[i][j].display = name;
                    }
                    else if (this.labelFormat === "both") {
                        this.dataLabels[i][j].display = name + ": " + value.toString();
                    }
                }
            }
        }
        else if (this.dataType === "single") {
            for (let i = 0; i < this.dataLabels.length; i++) {
                const { value } = this.dataLabels[i];
                let calc = value / 2;
                calc = ((this.view[1] - 20) * calc) / this.maxValue;
                calc -= 5;
                this.dataLabels[i].barHeight =
                    ((this.view[1] - 20) * value) / this.maxValue;
                this.dataLabels[i].height = calc.toString() + "px";
                if (this.labelFormat === "value") {
                    this.dataLabels[i].display = value;
                }
                else if (this.labelFormat === "name") {
                    this.dataLabels[i].display = name;
                }
                else if (this.labelFormat === "both") {
                    this.dataLabels[i].display = name + ": " + value.toSting();
                }
            }
        }
    }
    processTotals() {
        for (let i = 0; i < this.totals.length; i++) {
            let barHeight = 0;
            if (this.maxValue > 0 && this.dataLabels && this.dataLabels[i]) {
                this.dataLabels[i].forEach(series => {
                    barHeight += (series.value / this.maxValue) * (this.view[1] - 20);
                });
            }
            this.totals[i].heightString = (barHeight + 10).toString() + "px";
        }
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomXAxisComponent.prototype, "names", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomXAxisComponent.prototype, "view", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomXAxisComponent.prototype, "dataType", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomXAxisComponent.prototype, "showDataLabels", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomXAxisComponent.prototype, "dataLabels", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomXAxisComponent.prototype, "showTotals", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomXAxisComponent.prototype, "totals", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomXAxisComponent.prototype, "labelFormat", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomXAxisComponent.prototype, "maxValue", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomXAxisComponent.prototype, "barPadding", void 0);
CustomXAxisComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-custom-x-axis",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./custom-x-axis.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/custom-x-axis/custom-x-axis.component.html")).default,
        changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectionStrategy"].OnPush,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./custom-x-axis.component.scss */ "./src/app/modules/signage/components/custom-x-axis/custom-x-axis.component.scss")).default]
    })
], CustomXAxisComponent);



/***/ }),

/***/ "./src/app/modules/signage/components/custom-y-axis/custom-y-axis.component.scss":
/*!***************************************************************************************!*\
  !*** ./src/app/modules/signage/components/custom-y-axis/custom-y-axis.component.scss ***!
  \***************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".container {\n  display: flex;\n  width: 100%;\n}\n\n.tick {\n  font-size: 1.5rem;\n  text-align: end;\n}\n\n.label {\n  width: 40%;\n  text-align: center;\n}\n\n.tickLine {\n  display: inline-block;\n  position: relative;\n  right: 5px;\n  background-color: #444444;\n  height: 1px;\n  z-index: -1;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvbW9kdWxlcy9zaWduYWdlL2NvbXBvbmVudHMvY3VzdG9tLXktYXhpcy9DOlxcVXNlcnNcXFJpY2hhcmRcXERvY3VtZW50c1xcXzAwZGlnaXRhbC1zaWduYWdlXFxkaWdpdGFsLXNpZ25hZ2Uvc3JjXFxhcHBcXG1vZHVsZXNcXHNpZ25hZ2VcXGNvbXBvbmVudHNcXGN1c3RvbS15LWF4aXNcXGN1c3RvbS15LWF4aXMuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL21vZHVsZXMvc2lnbmFnZS9jb21wb25lbnRzL2N1c3RvbS15LWF4aXMvY3VzdG9tLXktYXhpcy5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGFBQUE7RUFDQSxXQUFBO0FDQ0Y7O0FERUE7RUFDRSxpQkFBQTtFQUNBLGVBQUE7QUNDRjs7QURFQTtFQUNFLFVBQUE7RUFDQSxrQkFBQTtBQ0NGOztBREVBO0VBQ0UscUJBQUE7RUFDQSxrQkFBQTtFQUNBLFVBQUE7RUFDQSx5QkFBQTtFQUNBLFdBQUE7RUFDQSxXQUFBO0FDQ0YiLCJmaWxlIjoic3JjL2FwcC9tb2R1bGVzL3NpZ25hZ2UvY29tcG9uZW50cy9jdXN0b20teS1heGlzL2N1c3RvbS15LWF4aXMuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuY29udGFpbmVyIHtcclxuICBkaXNwbGF5OiBmbGV4O1xyXG4gIHdpZHRoOiAxMDAlO1xyXG59XHJcblxyXG4udGljayB7XHJcbiAgZm9udC1zaXplOiAxLjVyZW07XHJcbiAgdGV4dC1hbGlnbjogZW5kO1xyXG59XHJcblxyXG4ubGFiZWwge1xyXG4gIHdpZHRoOiA0MCU7XHJcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xyXG59XHJcblxyXG4udGlja0xpbmUge1xyXG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcclxuICBwb3NpdGlvbjogcmVsYXRpdmU7XHJcbiAgcmlnaHQ6IDVweDtcclxuICBiYWNrZ3JvdW5kLWNvbG9yOiAjNDQ0NDQ0O1xyXG4gIGhlaWdodDogMXB4O1xyXG4gIHotaW5kZXg6IC0xO1xyXG59XHJcbiIsIi5jb250YWluZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICB3aWR0aDogMTAwJTtcbn1cblxuLnRpY2sge1xuICBmb250LXNpemU6IDEuNXJlbTtcbiAgdGV4dC1hbGlnbjogZW5kO1xufVxuXG4ubGFiZWwge1xuICB3aWR0aDogNDAlO1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG59XG5cbi50aWNrTGluZSB7XG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICByaWdodDogNXB4O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjNDQ0NDQ0O1xuICBoZWlnaHQ6IDFweDtcbiAgei1pbmRleDogLTE7XG59Il19 */");

/***/ }),

/***/ "./src/app/modules/signage/components/custom-y-axis/custom-y-axis.component.ts":
/*!*************************************************************************************!*\
  !*** ./src/app/modules/signage/components/custom-y-axis/custom-y-axis.component.ts ***!
  \*************************************************************************************/
/*! exports provided: CustomYAxisComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomYAxisComponent", function() { return CustomYAxisComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let CustomYAxisComponent = class CustomYAxisComponent {
    constructor() {
        this.tickArray = [];
    }
    ngOnInit() { }
    ngOnChanges() {
        this.totalHeight = this.view[1].toString() + "px";
        this.labelPos = (this.view[1] / 2 - 20).toString() + "px";
        if (this.maxValue === 0) {
            this.maxValue = 1;
        }
        this.tickLineWidth = (this.view[0] + 20).toString() + "px";
        this.setTickLength();
        this.setTickArray();
        this.setTickArrayHeight();
    }
    setTickLength() {
        if (this.maxValue <= 11) {
            this.tickLength = 1;
        }
        else if (this.maxValue <= 22) {
            this.tickLength = 2;
        }
        else if (this.maxValue <= 55) {
            this.tickLength = 5;
        }
        else if (this.maxValue <= 110) {
            this.tickLength = 10;
        }
        else if (this.maxValue <= 200) {
            this.tickLength = 20;
        }
        else if (this.maxValue <= 550) {
            this.tickLength = 50;
        }
        else {
            this.tickLength = 100;
        }
    }
    setTickArray() {
        this.tickArray = [];
        const topTick = this.maxValue - (this.maxValue % this.tickLength);
        for (let i = topTick; i >= 0; i = i - this.tickLength) {
            this.tickArray.push(i);
        }
    }
    setTickArrayHeight() {
        this.tickArrayHeight =
            (((this.view[1] - 5) * this.tickArray[0]) / this.maxValue).toString() +
                "px";
        this.tickLinesHeight =
            (((this.view[1] - 21) * this.tickArray[0]) / this.maxValue).toString() +
                "px";
        this.tickArrayMargin =
            (this.view[1] +
                1 -
                (this.view[1] * this.tickArray[0]) / this.maxValue).toString() + "px";
        this.tickLinesMargin =
            (this.view[1] +
                10 -
                (this.view[1] * this.tickArray[0]) / this.maxValue).toString() + "px";
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomYAxisComponent.prototype, "view", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomYAxisComponent.prototype, "label", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CustomYAxisComponent.prototype, "maxValue", void 0);
CustomYAxisComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-custom-y-axis",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./custom-y-axis.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/custom-y-axis/custom-y-axis.component.html")).default,
        changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectionStrategy"].OnPush,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./custom-y-axis.component.scss */ "./src/app/modules/signage/components/custom-y-axis/custom-y-axis.component.scss")).default]
    })
], CustomYAxisComponent);



/***/ }),

/***/ "./src/app/modules/signage/components/jobs-not-completed/jobs-not-completed.component.scss":
/*!*************************************************************************************************!*\
  !*** ./src/app/modules/signage/components/jobs-not-completed/jobs-not-completed.component.scss ***!
  \*************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".timestamp {\n  text-align: center;\n  font-size: 1.4rem;\n  font-weight: 400;\n  max-height: 40px;\n  width: 33%;\n  position: absolute;\n  top: 6%;\n}\n\n.cardContainer {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n}\n\n.jobCard {\n  flex-shrink: 0;\n  text-align: center;\n  background-color: #e5dcef;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  margin: 10px;\n  border-radius: 10px;\n}\n\n.title {\n  font-size: 1.3rem;\n  font-weight: 600;\n  letter-spacing: 1px;\n  display: flex;\n}\n\n.jobNumber {\n  font-size: 1.5rem;\n}\n\n.title,\n.titleContent,\n.jobNumber {\n  width: 100%;\n  min-height: 50%;\n  margin: auto;\n}\n\n.engineers,\n.lastStatus {\n  width: 49%;\n  height: 49%;\n  flex-grow: 1;\n  font-weight: 500;\n  font-size: 1.2rem;\n}\n\n.heading {\n  font-size: 1.3rem;\n  margin-bottom: 10px;\n}\n\n.noData {\n  margin-top: 25%;\n  font-size: 2rem;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/modules/signage/components/jobs-not-completed/jobs-not-completed.component.ts":
/*!***********************************************************************************************!*\
  !*** ./src/app/modules/signage/components/jobs-not-completed/jobs-not-completed.component.ts ***!
  \***********************************************************************************************/
/*! exports provided: JobsNotCompletedComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobsNotCompletedComponent", function() { return JobsNotCompletedComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_http_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../services/http.service */ "./src/app/modules/signage/services/http.service.ts");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);




let JobsNotCompletedComponent = class JobsNotCompletedComponent {
    constructor(dataService) {
        this.dataService = dataService;
        this.cardDims = ["240px", "135px"];
        this.largest = ["480px", "270px"];
        this.large = ["320px", "180px"];
        this.medium = ["240px", "135px"];
        this.small = ["160px", "90px"];
        this.getScreenSize();
    }
    getScreenSize(event) {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
    }
    ngOnInit() {
        this.getJobsData();
    }
    ngOnChanges() {
        this.getScreenSize();
        this.getJobsData();
    }
    getJobsData() {
        if (this.jobsDataSubscription) {
            this.jobsDataSubscription.unsubscribe();
        }
        this.jobsDataSubscription = this.dataService
            .getFromFirestore("", "jobsNotCompletedInApp")
            .subscribe(result => {
            this.jobsData = result[0].data;
            this.timestamp = result[0].lastUpdated;
            this.timeString = this.setTimeString();
            this.setCardSizes();
        });
    }
    setTimeString() {
        let string = "Last Updated ";
        const updatedMoment = moment__WEBPACK_IMPORTED_MODULE_3__["unix"](this.timestamp.seconds);
        string += updatedMoment.format("DD/MM - HH:mm");
        return string;
    }
    setCardSizes() {
        if (this.screenHeight && this.screenWidth && this.jobsData) {
            if (Math.floor((this.screenWidth - 100) / parseInt(this.largest[0])) *
                Math.floor((this.screenHeight * 0.85) / parseInt(this.largest[1])) >=
                this.jobsData.length) {
                this.cardDims = this.largest;
            }
            else if (Math.floor((this.screenWidth - 100) / parseInt(this.large[0])) *
                Math.floor((this.screenHeight * 0.85) / parseInt(this.large[1])) >=
                this.jobsData.length) {
                this.cardDims = this.large;
            }
            else if (Math.floor((this.screenWidth - 100) / parseInt(this.medium[0])) *
                Math.floor((this.screenHeight * 0.85) / parseInt(this.medium[1])) >=
                this.jobsData.length) {
                this.cardDims = this.medium;
            }
            else {
                this.cardDims = this.small;
            }
        }
    }
    ngOnDestroy() {
        if (this.jobsDataSubscription) {
            this.jobsDataSubscription.unsubscribe();
        }
    }
};
JobsNotCompletedComponent.ctorParameters = () => [
    { type: _services_http_service__WEBPACK_IMPORTED_MODULE_2__["HttpService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["HostListener"])("window:resize", ["$event"])
], JobsNotCompletedComponent.prototype, "getScreenSize", null);
JobsNotCompletedComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-jobs-not-completed",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./jobs-not-completed.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/jobs-not-completed/jobs-not-completed.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./jobs-not-completed.component.scss */ "./src/app/modules/signage/components/jobs-not-completed/jobs-not-completed.component.scss")).default]
    })
], JobsNotCompletedComponent);



/***/ }),

/***/ "./src/app/modules/signage/components/jobs/jobs.component.scss":
/*!*********************************************************************!*\
  !*** ./src/app/modules/signage/components/jobs/jobs.component.scss ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".flex-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  margin-top: 1%;\n  height: 80%;\n}\n\n.chart-container {\n  width: 50%;\n  height: 100%;\n}\n\nh1 {\n  text-align: center;\n}\n\napp-custom-legend {\n  height: 20%;\n  width: 100%;\n}\n\n.timestamp {\n  text-align: center;\n  font-size: 1.4rem;\n  font-weight: 400;\n  max-height: 40px;\n  width: 33%;\n  position: absolute;\n  top: 6%;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/modules/signage/components/jobs/jobs.component.ts":
/*!*******************************************************************!*\
  !*** ./src/app/modules/signage/components/jobs/jobs.component.ts ***!
  \*******************************************************************/
/*! exports provided: JobsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobsComponent", function() { return JobsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_http_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../services/http.service */ "./src/app/modules/signage/services/http.service.ts");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);




let JobsComponent = class JobsComponent {
    constructor(dataService) {
        this.dataService = dataService;
        this.dataFormat = "single";
        this.showText = true;
        this.getScreenSize();
    }
    getScreenSize(event) {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
        if (this.screenWidth < 960) {
            this.showText = false;
        }
        else {
            this.showText = true;
        }
    }
    ngOnInit() {
        this.dataService
            .getFromFirestore("User", "jobsAddedAndBookedPer")
            .subscribe(result => {
            this.data = result[0].data;
            this.timestamp = result[0].lastUpdated;
            this.timeString = this.setTimeString();
        });
        this.dataService
            .getFromFirestore("", "customUserColours")
            .subscribe(result => {
            this.usersData = result[0].data;
        });
    }
    setTimeString() {
        let string = "Last Updated ";
        const updatedMoment = moment__WEBPACK_IMPORTED_MODULE_3__["unix"](this.timestamp.seconds);
        string += updatedMoment.format("DD/MM - HH:mm");
        return string;
    }
    ngOnDestroy() {
        if (this.dataSubscription) {
            this.dataSubscription.unsubscribe();
        }
    }
};
JobsComponent.ctorParameters = () => [
    { type: _services_http_service__WEBPACK_IMPORTED_MODULE_2__["HttpService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], JobsComponent.prototype, "dataSource", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["HostListener"])("window:resize", ["$event"])
], JobsComponent.prototype, "getScreenSize", null);
JobsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-jobs",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./jobs.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/jobs/jobs.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./jobs.component.scss */ "./src/app/modules/signage/components/jobs/jobs.component.scss")).default]
    })
], JobsComponent);



/***/ }),

/***/ "./src/app/modules/signage/components/outstanding-tasks-per-group/outstanding-tasks-per-group.component.scss":
/*!*******************************************************************************************************************!*\
  !*** ./src/app/modules/signage/components/outstanding-tasks-per-group/outstanding-tasks-per-group.component.scss ***!
  \*******************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.subtitle {\n  text-align: center;\n  width: 100%;\n}\n\n.users {\n  position: relative;\n  bottom: 10%;\n  width: 20%;\n  height: 95%;\n}\n\n.userGauge {\n  height: 33%;\n  width: 200%;\n  display: inline-block;\n  overflow: hidden;\n  position: relative;\n}\n\n.userGauge app-custom-guage-chart {\n  position: absolute;\n  top: 0;\n  left: -5%;\n  font-weight: 700;\n}\n\n.main {\n  position: relative;\n  bottom: 2%;\n  height: 95%;\n  width: 60%;\n  font-weight: 700;\n}\n\n.timestamp {\n  text-align: center;\n  font-size: 1.4rem;\n  font-weight: 400;\n  max-height: 40px;\n  width: 33%;\n  position: absolute;\n  top: 6%;\n}\n\n.overdues {\n  position: relative;\n  bottom: 5%;\n  width: 20%;\n}\n\n.sectionTitle {\n  position: relative;\n  top: 20px;\n  text-align: center;\n}\n\n.row {\n  margin-bottom: 4%;\n}\n\n.rowItem {\n  display: inline-block;\n  width: 33%;\n  text-align: center;\n  font-size: 1.5rem;\n}\n\n.name {\n  margin: 0 auto;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvbW9kdWxlcy9zaWduYWdlL2NvbXBvbmVudHMvb3V0c3RhbmRpbmctdGFza3MtcGVyLWdyb3VwL0M6XFxVc2Vyc1xcUmljaGFyZFxcRG9jdW1lbnRzXFxfMDBkaWdpdGFsLXNpZ25hZ2VcXGRpZ2l0YWwtc2lnbmFnZS9zcmNcXGFwcFxcbW9kdWxlc1xcc2lnbmFnZVxcY29tcG9uZW50c1xcb3V0c3RhbmRpbmctdGFza3MtcGVyLWdyb3VwXFxvdXRzdGFuZGluZy10YXNrcy1wZXItZ3JvdXAuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL21vZHVsZXMvc2lnbmFnZS9jb21wb25lbnRzL291dHN0YW5kaW5nLXRhc2tzLXBlci1ncm91cC9vdXRzdGFuZGluZy10YXNrcy1wZXItZ3JvdXAuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxXQUFBO0VBQ0EsWUFBQTtFQUNBLGFBQUE7RUFDQSxlQUFBO0FDQ0Y7O0FERUE7RUFDRSxrQkFBQTtFQUNBLFdBQUE7QUNDRjs7QURFQTtFQUNFLGtCQUFBO0VBQ0EsV0FBQTtFQUNBLFVBQUE7RUFDQSxXQUFBO0FDQ0Y7O0FERUE7RUFDRSxXQUFBO0VBQ0EsV0FBQTtFQUNBLHFCQUFBO0VBQ0EsZ0JBQUE7RUFDQSxrQkFBQTtBQ0NGOztBREVBO0VBQ0Usa0JBQUE7RUFDQSxNQUFBO0VBQ0EsU0FBQTtFQUNBLGdCQUFBO0FDQ0Y7O0FERUE7RUFDRSxrQkFBQTtFQUNBLFVBQUE7RUFDQSxXQUFBO0VBQ0EsVUFBQTtFQUNBLGdCQUFBO0FDQ0Y7O0FERUE7RUFDRSxrQkFBQTtFQUNBLGlCQUFBO0VBQ0EsZ0JBQUE7RUFDQSxnQkFBQTtFQUNBLFVBQUE7RUFDQSxrQkFBQTtFQUNBLE9BQUE7QUNDRjs7QURFQTtFQUNFLGtCQUFBO0VBQ0EsVUFBQTtFQUNBLFVBQUE7QUNDRjs7QURFQTtFQUNFLGtCQUFBO0VBQ0EsU0FBQTtFQUNBLGtCQUFBO0FDQ0Y7O0FERUE7RUFDRSxpQkFBQTtBQ0NGOztBREVBO0VBQ0UscUJBQUE7RUFDQSxVQUFBO0VBQ0Esa0JBQUE7RUFDQSxpQkFBQTtBQ0NGOztBREVBO0VBQ0UsY0FBQTtBQ0NGIiwiZmlsZSI6InNyYy9hcHAvbW9kdWxlcy9zaWduYWdlL2NvbXBvbmVudHMvb3V0c3RhbmRpbmctdGFza3MtcGVyLWdyb3VwL291dHN0YW5kaW5nLXRhc2tzLXBlci1ncm91cC5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5jb250YWluZXIge1xyXG4gIHdpZHRoOiAxMDAlO1xyXG4gIGhlaWdodDogMTAwJTtcclxuICBkaXNwbGF5OiBmbGV4O1xyXG4gIGZsZXgtd3JhcDogd3JhcDtcclxufVxyXG5cclxuLnN1YnRpdGxlIHtcclxuICB0ZXh0LWFsaWduOiBjZW50ZXI7XHJcbiAgd2lkdGg6IDEwMCU7XHJcbn1cclxuXHJcbi51c2VycyB7XHJcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xyXG4gIGJvdHRvbTogMTAlO1xyXG4gIHdpZHRoOiAyMCU7XHJcbiAgaGVpZ2h0OiA5NSU7XHJcbn1cclxuXHJcbi51c2VyR2F1Z2Uge1xyXG4gIGhlaWdodDogMzMlO1xyXG4gIHdpZHRoOiAyMDAlO1xyXG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcclxuICBvdmVyZmxvdzogaGlkZGVuO1xyXG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcclxufVxyXG5cclxuLnVzZXJHYXVnZSBhcHAtY3VzdG9tLWd1YWdlLWNoYXJ0IHtcclxuICBwb3NpdGlvbjogYWJzb2x1dGU7XHJcbiAgdG9wOiAwO1xyXG4gIGxlZnQ6IC01JTtcclxuICBmb250LXdlaWdodDogNzAwO1xyXG59XHJcblxyXG4ubWFpbiB7XHJcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xyXG4gIGJvdHRvbTogMiU7XHJcbiAgaGVpZ2h0OiA5NSU7XHJcbiAgd2lkdGg6IDYwJTtcclxuICBmb250LXdlaWdodDogNzAwO1xyXG59XHJcblxyXG4udGltZXN0YW1wIHtcclxuICB0ZXh0LWFsaWduOiBjZW50ZXI7XHJcbiAgZm9udC1zaXplOiAxLjRyZW07XHJcbiAgZm9udC13ZWlnaHQ6IDQwMDtcclxuICBtYXgtaGVpZ2h0OiA0MHB4O1xyXG4gIHdpZHRoOiAzMyU7XHJcbiAgcG9zaXRpb246IGFic29sdXRlO1xyXG4gIHRvcDogNiU7XHJcbn1cclxuXHJcbi5vdmVyZHVlcyB7XHJcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xyXG4gIGJvdHRvbTogNSU7XHJcbiAgd2lkdGg6IDIwJTtcclxufVxyXG5cclxuLnNlY3Rpb25UaXRsZSB7XHJcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xyXG4gIHRvcDogMjBweDtcclxuICB0ZXh0LWFsaWduOiBjZW50ZXI7XHJcbn1cclxuXHJcbi5yb3cge1xyXG4gIG1hcmdpbi1ib3R0b206IDQlO1xyXG59XHJcblxyXG4ucm93SXRlbSB7XHJcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xyXG4gIHdpZHRoOiAzMyU7XHJcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xyXG4gIGZvbnQtc2l6ZTogMS41cmVtO1xyXG59XHJcblxyXG4ubmFtZSB7XHJcbiAgbWFyZ2luOiAwIGF1dG87XHJcbn1cclxuIiwiLmNvbnRhaW5lciB7XG4gIHdpZHRoOiAxMDAlO1xuICBoZWlnaHQ6IDEwMCU7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtd3JhcDogd3JhcDtcbn1cblxuLnN1YnRpdGxlIHtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICB3aWR0aDogMTAwJTtcbn1cblxuLnVzZXJzIHtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICBib3R0b206IDEwJTtcbiAgd2lkdGg6IDIwJTtcbiAgaGVpZ2h0OiA5NSU7XG59XG5cbi51c2VyR2F1Z2Uge1xuICBoZWlnaHQ6IDMzJTtcbiAgd2lkdGg6IDIwMCU7XG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xufVxuXG4udXNlckdhdWdlIGFwcC1jdXN0b20tZ3VhZ2UtY2hhcnQge1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRvcDogMDtcbiAgbGVmdDogLTUlO1xuICBmb250LXdlaWdodDogNzAwO1xufVxuXG4ubWFpbiB7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgYm90dG9tOiAyJTtcbiAgaGVpZ2h0OiA5NSU7XG4gIHdpZHRoOiA2MCU7XG4gIGZvbnQtd2VpZ2h0OiA3MDA7XG59XG5cbi50aW1lc3RhbXAge1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gIGZvbnQtc2l6ZTogMS40cmVtO1xuICBmb250LXdlaWdodDogNDAwO1xuICBtYXgtaGVpZ2h0OiA0MHB4O1xuICB3aWR0aDogMzMlO1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRvcDogNiU7XG59XG5cbi5vdmVyZHVlcyB7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgYm90dG9tOiA1JTtcbiAgd2lkdGg6IDIwJTtcbn1cblxuLnNlY3Rpb25UaXRsZSB7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgdG9wOiAyMHB4O1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG59XG5cbi5yb3cge1xuICBtYXJnaW4tYm90dG9tOiA0JTtcbn1cblxuLnJvd0l0ZW0ge1xuICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gIHdpZHRoOiAzMyU7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgZm9udC1zaXplOiAxLjVyZW07XG59XG5cbi5uYW1lIHtcbiAgbWFyZ2luOiAwIGF1dG87XG59Il19 */");

/***/ }),

/***/ "./src/app/modules/signage/components/outstanding-tasks-per-group/outstanding-tasks-per-group.component.ts":
/*!*****************************************************************************************************************!*\
  !*** ./src/app/modules/signage/components/outstanding-tasks-per-group/outstanding-tasks-per-group.component.ts ***!
  \*****************************************************************************************************************/
/*! exports provided: OutstandingTasksPerGroupComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OutstandingTasksPerGroupComponent", function() { return OutstandingTasksPerGroupComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_http_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./../../services/http.service */ "./src/app/modules/signage/services/http.service.ts");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);




let OutstandingTasksPerGroupComponent = class OutstandingTasksPerGroupComponent {
    constructor(dataService) {
        this.dataService = dataService;
        this.showAxis = true;
        this.colourScheme = { domain: ["#6ebf6e", "#f2b764", "#e27d79"] };
        this.userGaugeDims = [560, 560];
        this.getScreenSize();
    }
    getScreenSize(event) {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
        if (this.screenWidth < 1450) {
            this.showAxis = false;
            this.userGaugeDims = [this.screenHeight / 2, this.screenHeight / 2];
        }
        else {
            this.showAxis = true;
            this.userGaugeDims = [
                (this.screenHeight * 5) / 9,
                (this.screenHeight * 5) / 9
            ];
        }
    }
    ngOnInit() {
        this.usersDataSubscription = this.dataService
            .getFromFirestore("", "customUserColours")
            .subscribe(result => {
            this.usersData = result[0].data;
            this.attachColoursToOverdues();
        });
    }
    ngOnChanges() {
        this.getOutstandingTasksData();
        this.getOverdueTasksData();
    }
    ngOnDestroy() {
        //prevent data leaks
        if (this.outstandingDataSubscription) {
            this.outstandingDataSubscription.unsubscribe();
        }
        if (this.overdueDataSubscription) {
            this.overdueDataSubscription.unsubscribe();
        }
        if (this.usersDataSubscription) {
            this.usersDataSubscription.unsubscribe();
        }
    }
    getOutstandingTasksData() {
        if (this.outstandingDataSubscription) {
            this.outstandingDataSubscription.unsubscribe();
        }
        this.outstandingDataSubscription = this.dataService
            .getFromFirestore(this.subtitle, "outstandingTasksPer")
            .subscribe(result => {
            this.outstandingData = result[0].data;
            this.timestamp = result[0].lastUpdated;
            this.timeString = this.setTimeString();
        });
    }
    setTimeString() {
        let string = "Last Updated ";
        const updatedMoment = moment__WEBPACK_IMPORTED_MODULE_3__["unix"](this.timestamp.seconds);
        string += updatedMoment.format("DD/MM - HH:mm");
        return string;
    }
    getOverdueTasksData() {
        if (this.overdueDataSubscription) {
            this.overdueDataSubscription.unsubscribe();
        }
        this.overdueDataSubscription = this.dataService
            .getFromFirestore(this.subtitle, "overdueTasksPer")
            .subscribe(result => {
            this.overdueData = result[0].data;
            this.attachColoursToOverdues();
        });
    }
    attachColoursToOverdues() {
        if (this.overdueData && this.usersData) {
            for (let i = 0; i < this.overdueData.length; i++) {
                for (let j = 0, found = false; j < this.usersData.length && found === false; j++) {
                    if (this.overdueData[i].firstname +
                        " " +
                        this.overdueData[i].lastname ===
                        this.usersData[j].name) {
                        found = true;
                        this.overdueData[i].value = this.usersData[j].value;
                    }
                }
            }
        }
    }
};
OutstandingTasksPerGroupComponent.ctorParameters = () => [
    { type: _services_http_service__WEBPACK_IMPORTED_MODULE_2__["HttpService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], OutstandingTasksPerGroupComponent.prototype, "subtitle", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["HostListener"])("window:resize", ["$event"])
], OutstandingTasksPerGroupComponent.prototype, "getScreenSize", null);
OutstandingTasksPerGroupComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-outstanding-tasks-per-group",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./outstanding-tasks-per-group.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/outstanding-tasks-per-group/outstanding-tasks-per-group.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./outstanding-tasks-per-group.component.scss */ "./src/app/modules/signage/components/outstanding-tasks-per-group/outstanding-tasks-per-group.component.scss")).default]
    })
], OutstandingTasksPerGroupComponent);



/***/ }),

/***/ "./src/app/modules/signage/components/predicted-reds-ambers-per-user/predicted-reds-ambers-per-user.component.scss":
/*!*************************************************************************************************************************!*\
  !*** ./src/app/modules/signage/components/predicted-reds-ambers-per-user/predicted-reds-ambers-per-user.component.scss ***!
  \*************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".timestamp {\n  text-align: center;\n  font-size: 1.4rem;\n  font-weight: 400;\n  max-height: 40px;\n  width: 33%;\n  position: absolute;\n  top: 6%;\n}\n\n.subtitle {\n  text-align: center;\n  width: 100%;\n}\n\n.chart {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.yAxisTag {\n  text-anchor: end;\n  font-size: 1.3rem;\n}\n\n.xAxisTick {\n  font-size: 1.3rem;\n}\n\n.legend {\n  width: 100%;\n  margin-top: 20px;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/modules/signage/components/predicted-reds-ambers-per-user/predicted-reds-ambers-per-user.component.ts":
/*!***********************************************************************************************************************!*\
  !*** ./src/app/modules/signage/components/predicted-reds-ambers-per-user/predicted-reds-ambers-per-user.component.ts ***!
  \***********************************************************************************************************************/
/*! exports provided: PredictedRedsAmbersPerUserComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PredictedRedsAmbersPerUserComponent", function() { return PredictedRedsAmbersPerUserComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_http_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../services/http.service */ "./src/app/modules/signage/services/http.service.ts");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);




let PredictedRedsAmbersPerUserComponent = class PredictedRedsAmbersPerUserComponent {
    constructor(dataService) {
        this.dataService = dataService;
        this.rows = [];
        this.xTicks = [];
        this.getScreenSize();
    }
    getScreenSize(event) {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
        if (this.screenWidth < 1450) {
            this.viewHeight = this.screenHeight * 0.45;
            this.yAxisWidth = 90;
            this.xAxisHeight = 30;
            if (this.screenWidth < 960) {
                this.yAxisWidth = 70;
            }
        }
        else if (this.screenWidth < 1680) {
            this.viewHeight = this.screenHeight * 0.6;
            this.yAxisWidth = 120;
            this.xAxisHeight = 40;
        }
        else {
            this.viewHeight = this.screenHeight * 0.65;
            this.yAxisWidth = 150;
            this.xAxisHeight = 50;
        }
        this.viewWidth = this.screenWidth * 0.9;
        this.chartHeight = this.viewHeight - this.xAxisHeight;
        this.chartWidth = this.viewWidth - this.yAxisWidth;
        this.setRowHeight();
    }
    ngOnInit() {
        this.usersDataSubscription = this.dataService
            .getFromFirestore("", "customUserColours")
            .subscribe(result => {
            this.usersData = result[0].data;
            this.usersData.push({ name: "Group", value: "rgb(0,0,0)" });
            this.attachCustomColours();
        });
    }
    ngOnChanges() {
        if (this.predictionsDataSubscription) {
            this.predictionsDataSubscription.unsubscribe();
        }
        this.predictionsDataSubscription = this.dataService
            .getFromFirestore(this.subtitle, "predictedRedsAmbersPer")
            .subscribe(result => {
            this.predictionsData = result[0].data;
            if (this.predictionsData.maxValue) {
                this.maxValue = this.predictionsData.maxValue;
            }
            this.rows = this.predictionsData.predictionsData[0].predictedAmbersByDay;
            this.timestamp = result[0].lastUpdated;
            this.timeString = this.setTimeString();
            this.attachCustomColours();
            this.setRowHeight();
            this.setXTicks();
        });
    }
    attachCustomColours() {
        if (this.predictionsData && this.usersData) {
            this.predictionsData.predictionsData.forEach(user => {
                const userColour = this.usersData.find(colour => colour.name == user.name);
                if (userColour) {
                    user.colour = userColour.value;
                }
            });
        }
    }
    setTimeString() {
        let string = "Last Updated ";
        const updatedMoment = moment__WEBPACK_IMPORTED_MODULE_3__["unix"](this.timestamp.seconds);
        string += updatedMoment.format("DD/MM - HH:mm");
        return string;
    }
    setRowHeight() {
        if (this.rows.length > 0) {
            this.rowHeight = this.chartHeight / (2 * this.rows.length);
        }
        else {
            this.rowHeight = this.chartHeight / 2;
        }
        this.circleRadius = Math.min(20, this.rowHeight * 0.45);
    }
    setXTicks() {
        let tickLength = 0;
        if (this.maxValue <= 11) {
            tickLength = 1;
        }
        else if (this.maxValue <= 22) {
            tickLength = 2;
        }
        else if (this.maxValue <= 55) {
            tickLength = 5;
        }
        else if (this.maxValue <= 110) {
            tickLength = 10;
        }
        else if (this.maxValue <= 200) {
            tickLength = 20;
        }
        else if (this.maxValue <= 550) {
            tickLength = 50;
        }
        else {
            tickLength = 100;
        }
        this.xTicks = [];
        const rightTick = this.maxValue - (this.maxValue % tickLength);
        for (let i = rightTick; i >= 0; i = i - tickLength) {
            this.xTicks.push(i);
        }
    }
    ngOnDestroy() {
        if (this.usersDataSubscription) {
            this.usersDataSubscription.unsubscribe();
        }
        if (this.predictionsDataSubscription) {
            this.predictionsDataSubscription.unsubscribe();
        }
    }
};
PredictedRedsAmbersPerUserComponent.ctorParameters = () => [
    { type: _services_http_service__WEBPACK_IMPORTED_MODULE_2__["HttpService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], PredictedRedsAmbersPerUserComponent.prototype, "subtitle", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["HostListener"])("window:resize", ["$event"])
], PredictedRedsAmbersPerUserComponent.prototype, "getScreenSize", null);
PredictedRedsAmbersPerUserComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-predicted-reds-ambers-per-user",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./predicted-reds-ambers-per-user.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/predicted-reds-ambers-per-user/predicted-reds-ambers-per-user.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./predicted-reds-ambers-per-user.component.scss */ "./src/app/modules/signage/components/predicted-reds-ambers-per-user/predicted-reds-ambers-per-user.component.scss")).default]
    })
], PredictedRedsAmbersPerUserComponent);



/***/ }),

/***/ "./src/app/modules/signage/components/signage-slider/signage-slider.component.scss":
/*!*****************************************************************************************!*\
  !*** ./src/app/modules/signage/components/signage-slider/signage-slider.component.scss ***!
  \*****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".container {\n  width: 98%;\n  height: 98%;\n  margin-left: 1%;\n  margin-top: 1%;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  overflow: hidden;\n  position: relative;\n}\n\n.topBar {\n  display: flex;\n  text-align: center;\n  width: 100%;\n  height: 8%;\n  justify-content: space-around;\n}\n\n.topBarItem {\n  flex: 1 0 33%;\n}\n\n.prev,\n.next {\n  position: relative;\n  background-color: #8adbc0;\n  width: 60%;\n  margin: 0 auto 10px;\n  height: 30px;\n}\n\n.next::after {\n  content: \"\";\n  position: absolute;\n  left: -29px;\n  bottom: 0;\n  width: 0;\n  height: 0;\n  border-left: 15px solid transparent;\n  border-right: 15px solid #8adbc0;\n  border-top: 15px solid #8adbc0;\n  border-bottom: 15px solid #8adbc0;\n}\n\n.next::before {\n  content: \"\";\n  position: absolute;\n  right: -15px;\n  bottom: 0;\n  width: 0;\n  height: 0;\n  border-left: 15px solid #8adbc0;\n  border-top: 15px solid transparent;\n  border-bottom: 15px solid transparent;\n}\n\n.prev::after {\n  content: \"\";\n  position: absolute;\n  right: -29px;\n  bottom: 0;\n  width: 0;\n  height: 0;\n  border-right: 15px solid transparent;\n  border-left: 15px solid #8adbc0;\n  border-top: 15px solid #8adbc0;\n  border-bottom: 15px solid #8adbc0;\n}\n\n.prev::before {\n  content: \"\";\n  position: absolute;\n  left: -15px;\n  bottom: 0;\n  width: 0;\n  height: 0;\n  border-right: 15px solid #8adbc0;\n  border-top: 15px solid transparent;\n  border-bottom: 15px solid transparent;\n}\n\nh3 {\n  font-size: 1.4rem;\n  font-weight: 500;\n}\n\n.timer {\n  font-size: 1.2rem;\n}\n\n.childElement {\n  height: 92%;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/modules/signage/components/signage-slider/signage-slider.component.ts":
/*!***************************************************************************************!*\
  !*** ./src/app/modules/signage/components/signage-slider/signage-slider.component.ts ***!
  \***************************************************************************************/
/*! exports provided: SignageSliderComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SignageSliderComponent", function() { return SignageSliderComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let SignageSliderComponent = class SignageSliderComponent {
    constructor() {
        this.paused = false;
        this.groupsOfWork = [
            "Accounts",
            "Administrator",
            "Engineer",
            "Laboratory",
            "Manager",
            "Quality Assurance",
            "Sales Agent",
            "Superuser"
        ];
        this.slides = [
            {
                title: "Tasks Complete",
                subtitles: this.groupsOfWork
            },
            {
                title: "Tasks Outstanding",
                subtitles: this.groupsOfWork
            },
            {
                title: "Jobs",
                subtitles: ["Main"]
            },
            {
                title: "Jobs Not Complete",
                subtitles: ["Main"]
            },
            {
                title: "Booking Values",
                subtitles: ["Page 1", "Page 2", "Page 3"]
            },
            {
                title: "Predicted KPI Changes",
                subtitles: this.groupsOfWork
            }
        ];
        this.timerInit = 30;
        this.timeLeftString = "100%";
        this.currentTitle = 0;
        this.currentSubtitle = 0;
    }
    handleKeyboardEvent(event) {
        if (event.key === "a") {
            this.backOneSlide();
        }
        else if (event.key === "d") {
            this.forwardOneSlide();
        }
        else if (event.key === " ") {
            this.handlePausing();
        }
    }
    ngOnInit() {
        this.initFunction(false);
    }
    ngOnDestroy() {
        if (this.resetInterval) {
            clearInterval(this.resetInterval);
        }
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
        if (this.pauseTimeout) {
            clearTimeout(this.pauseTimeout);
        }
    }
    changeSlide(backwards) {
        //set the previous slide string before setting current strings
        if (this.currentSubtitle === 0) {
            this.previousString = this.titleString;
        }
        else {
            this.previousString = this.subtitleString;
        }
        this.titleString = this.slides[this.currentTitle].title;
        this.subtitleString = this.slides[this.currentTitle].subtitles[this.currentSubtitle];
        //increment current slide and set next slide string
        this.currentSubtitle++;
        if (this.currentSubtitle >= this.slides[this.currentTitle].subtitles.length) {
            this.currentSubtitle = 0;
            this.currentTitle++;
            if (this.currentTitle >= this.slides.length) {
                this.currentTitle = 0;
            }
            this.nextString = this.slides[this.currentTitle].title;
        }
        else {
            this.nextString = this.slides[this.currentTitle].subtitles[this.currentSubtitle];
        }
        if (backwards) {
            this.previousString = this.nextString;
        }
    }
    initFunction(backwards) {
        //initial changeSlide to display data as soon as the component loads
        this.changeSlide(backwards);
        if (!this.paused) {
            //setting the timer bar's width
            this.timerInterval = setInterval(() => {
                this.timer -= 0.1;
                let calc = 100 - (this.timer / this.timerInit) * 100;
                this.timeLeftString = calc.toString() + "%";
            }, 100);
            //setting up timed slide changes
            this.resetInterval = setInterval(() => {
                this.timer = this.timerInit;
                this.changeSlide(backwards);
            }, this.timerInit * 1000);
        }
        this.timer = this.timerInit;
        this.timeLeftString = "0%";
    }
    backOneSlide() {
        for (let i = 0; i < 2; i++) {
            if (this.currentSubtitle === 0) {
                if (this.currentTitle === 0) {
                    this.currentTitle = this.slides.length - 1;
                }
                else {
                    this.currentTitle--;
                }
                this.currentSubtitle =
                    this.slides[this.currentTitle].subtitles.length - 1;
            }
            else {
                this.currentSubtitle--;
            }
        }
        if (this.resetInterval) {
            clearInterval(this.resetInterval);
        }
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
        if (this.pauseTimeout) {
            clearTimeout(this.pauseTimeout);
        }
        this.initFunction(true);
    }
    forwardOneSlide() {
        if (this.resetInterval) {
            clearInterval(this.resetInterval);
        }
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
        if (this.pauseTimeout) {
            clearTimeout(this.pauseTimeout);
        }
        this.initFunction(false);
    }
    handlePausing() {
        if (this.paused) {
            this.timerInterval = setInterval(() => {
                this.timer -= 0.1;
                let calc = 100 - (this.timer / this.timerInit) * 100;
                this.timeLeftString = calc.toString() + "%";
            }, 100);
            this.pauseTimeout = setTimeout(() => {
                this.changeSlide(false);
                this.timer = this.timerInit;
                this.resetInterval = setInterval(() => {
                    this.timer = this.timerInit;
                    this.changeSlide(false);
                }, this.timerInit * 1000);
            }, this.timer * 1000);
            this.paused = false;
        }
        else {
            if (this.resetInterval) {
                clearInterval(this.resetInterval);
            }
            if (this.timerInterval) {
                clearInterval(this.timerInterval);
            }
            if (this.pauseTimeout) {
                clearTimeout(this.pauseTimeout);
            }
            this.paused = true;
        }
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["HostListener"])("document:keypress", ["$event"])
], SignageSliderComponent.prototype, "handleKeyboardEvent", null);
SignageSliderComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-signage-slider",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./signage-slider.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/signage-slider/signage-slider.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./signage-slider.component.scss */ "./src/app/modules/signage/components/signage-slider/signage-slider.component.scss")).default]
    })
], SignageSliderComponent);



/***/ }),

/***/ "./src/app/modules/signage/components/system-generated-tasks-per-user/system-generated-tasks-per-user.component.scss":
/*!***************************************************************************************************************************!*\
  !*** ./src/app/modules/signage/components/system-generated-tasks-per-user/system-generated-tasks-per-user.component.scss ***!
  \***************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".container {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.subtitle {\n  text-align: center;\n  width: 100%;\n}\n\nngx-charts-bar-vertical-stacked {\n  font-size: 2rem;\n  font-weight: 700;\n}\n\n.graphBody {\n  width: 90%;\n}\n\n.legend {\n  width: 100%;\n  margin-top: 110px;\n}\n\n.timestamp {\n  text-align: center;\n  font-size: 1.4rem;\n  font-weight: 400;\n  max-height: 40px;\n  width: 33%;\n  position: absolute;\n  top: 6%;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvbW9kdWxlcy9zaWduYWdlL2NvbXBvbmVudHMvc3lzdGVtLWdlbmVyYXRlZC10YXNrcy1wZXItdXNlci9DOlxcVXNlcnNcXFJpY2hhcmRcXERvY3VtZW50c1xcXzAwZGlnaXRhbC1zaWduYWdlXFxkaWdpdGFsLXNpZ25hZ2Uvc3JjXFxhcHBcXG1vZHVsZXNcXHNpZ25hZ2VcXGNvbXBvbmVudHNcXHN5c3RlbS1nZW5lcmF0ZWQtdGFza3MtcGVyLXVzZXJcXHN5c3RlbS1nZW5lcmF0ZWQtdGFza3MtcGVyLXVzZXIuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL21vZHVsZXMvc2lnbmFnZS9jb21wb25lbnRzL3N5c3RlbS1nZW5lcmF0ZWQtdGFza3MtcGVyLXVzZXIvc3lzdGVtLWdlbmVyYXRlZC10YXNrcy1wZXItdXNlci5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLFdBQUE7RUFDQSxhQUFBO0VBQ0EsZUFBQTtBQ0NGOztBREVBO0VBQ0Usa0JBQUE7RUFDQSxXQUFBO0FDQ0Y7O0FERUE7RUFDRSxlQUFBO0VBQ0EsZ0JBQUE7QUNDRjs7QURFQTtFQUNFLFVBQUE7QUNDRjs7QURFQTtFQUNFLFdBQUE7RUFDQSxpQkFBQTtBQ0NGOztBREVBO0VBQ0Usa0JBQUE7RUFDQSxpQkFBQTtFQUNBLGdCQUFBO0VBQ0EsZ0JBQUE7RUFDQSxVQUFBO0VBQ0Esa0JBQUE7RUFDQSxPQUFBO0FDQ0YiLCJmaWxlIjoic3JjL2FwcC9tb2R1bGVzL3NpZ25hZ2UvY29tcG9uZW50cy9zeXN0ZW0tZ2VuZXJhdGVkLXRhc2tzLXBlci11c2VyL3N5c3RlbS1nZW5lcmF0ZWQtdGFza3MtcGVyLXVzZXIuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuY29udGFpbmVyIHtcclxuICB3aWR0aDogMTAwJTtcclxuICBkaXNwbGF5OiBmbGV4O1xyXG4gIGZsZXgtd3JhcDogd3JhcDtcclxufVxyXG5cclxuLnN1YnRpdGxlIHtcclxuICB0ZXh0LWFsaWduOiBjZW50ZXI7XHJcbiAgd2lkdGg6IDEwMCU7XHJcbn1cclxuXHJcbm5neC1jaGFydHMtYmFyLXZlcnRpY2FsLXN0YWNrZWQge1xyXG4gIGZvbnQtc2l6ZTogMnJlbTtcclxuICBmb250LXdlaWdodDogNzAwO1xyXG59XHJcblxyXG4uZ3JhcGhCb2R5IHtcclxuICB3aWR0aDogOTAlO1xyXG59XHJcblxyXG4ubGVnZW5kIHtcclxuICB3aWR0aDogMTAwJTtcclxuICBtYXJnaW4tdG9wOiAxMTBweDtcclxufVxyXG5cclxuLnRpbWVzdGFtcCB7XHJcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xyXG4gIGZvbnQtc2l6ZTogMS40cmVtO1xyXG4gIGZvbnQtd2VpZ2h0OiA0MDA7XHJcbiAgbWF4LWhlaWdodDogNDBweDtcclxuICB3aWR0aDogMzMlO1xyXG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcclxuICB0b3A6IDYlO1xyXG59XHJcbiIsIi5jb250YWluZXIge1xuICB3aWR0aDogMTAwJTtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC13cmFwOiB3cmFwO1xufVxuXG4uc3VidGl0bGUge1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gIHdpZHRoOiAxMDAlO1xufVxuXG5uZ3gtY2hhcnRzLWJhci12ZXJ0aWNhbC1zdGFja2VkIHtcbiAgZm9udC1zaXplOiAycmVtO1xuICBmb250LXdlaWdodDogNzAwO1xufVxuXG4uZ3JhcGhCb2R5IHtcbiAgd2lkdGg6IDkwJTtcbn1cblxuLmxlZ2VuZCB7XG4gIHdpZHRoOiAxMDAlO1xuICBtYXJnaW4tdG9wOiAxMTBweDtcbn1cblxuLnRpbWVzdGFtcCB7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgZm9udC1zaXplOiAxLjRyZW07XG4gIGZvbnQtd2VpZ2h0OiA0MDA7XG4gIG1heC1oZWlnaHQ6IDQwcHg7XG4gIHdpZHRoOiAzMyU7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiA2JTtcbn0iXX0= */");

/***/ }),

/***/ "./src/app/modules/signage/components/system-generated-tasks-per-user/system-generated-tasks-per-user.component.ts":
/*!*************************************************************************************************************************!*\
  !*** ./src/app/modules/signage/components/system-generated-tasks-per-user/system-generated-tasks-per-user.component.ts ***!
  \*************************************************************************************************************************/
/*! exports provided: SystemGeneratedTasksPerUserComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SystemGeneratedTasksPerUserComponent", function() { return SystemGeneratedTasksPerUserComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_http_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../services/http.service */ "./src/app/modules/signage/services/http.service.ts");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);




let SystemGeneratedTasksPerUserComponent = class SystemGeneratedTasksPerUserComponent {
    constructor(dataService) {
        this.dataService = dataService;
        this.labels = [];
        this.totals = [];
        this.dataType = "multi";
        this.view = [1700, 550];
        this.colourScheme = {
            domain: [
                "#B9418E",
                "#42DAD0",
                "#E5DCEF",
                "#DF5331",
                "#E0C69E",
                "#F2BA3D",
                "#FF1A47",
                "#93F0A6",
                "#07ABF2",
                "#BF2327"
            ]
        };
        this.yAxisLabel = "Tasks Complete";
        this.showDataLabels = true;
        this.labelFormat = "value";
        this.getScreenSize();
    }
    getScreenSize(event) {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
        if (this.screenWidth < 1680) {
            this.view = [this.screenWidth * 0.85, this.screenHeight * 0.45];
        }
        else {
            this.view = [this.screenWidth * 0.85, this.screenHeight * 0.55];
        }
    }
    ngOnInit() { }
    ngOnChanges() {
        this.getScreenSize();
        this.yAxisHeight = (this.view[1] + 10).toString() + "px";
        this.getTaskTypesData();
        this.getTotalTasksData();
    }
    ngOnDestroy() {
        //prevent data leaks
        if (this.typesDataSubscription) {
            this.typesDataSubscription.unsubscribe();
        }
        if (this.totalDataSubscription) {
            this.totalDataSubscription.unsubscribe();
        }
    }
    getTaskTypesData() {
        if (this.typesDataSubscription) {
            this.typesDataSubscription.unsubscribe();
        }
        this.typesDataSubscription = this.dataService
            .getFromFirestore(this.subtitle, "completedTasksOfTypePer")
            .subscribe(result => {
            this.typesData = result[0].data;
            this.timestamp = result[0].lastUpdated;
            this.timeString = this.setTimeString();
            this.barPadding = (this.typesData.barPadding * this.view[0]) / 1700;
            this.labels = [];
            for (let i = 0; i < this.typesData.result.length; i++) {
                this.labels.push(this.typesData.result[i].series);
            }
            this.setTotals();
        });
    }
    setTimeString() {
        let string = "Last Updated ";
        const updatedMoment = moment__WEBPACK_IMPORTED_MODULE_3__["unix"](this.timestamp.seconds);
        string += updatedMoment.format("DD/MM - HH:mm");
        return string;
    }
    getTotalTasksData() {
        if (this.totalDataSubscription) {
            this.totalDataSubscription.unsubscribe();
        }
        this.totalDataSubscription = this.dataService
            .getFromFirestore(this.subtitle, "totalCompletedTasksPer")
            .subscribe(result => {
            this.totalData = result[0].data;
            this.setTotals();
        });
    }
    setTotals() {
        if (this.typesData && this.totalData) {
            this.totals = [];
            for (let i = 0; i < this.totalData.result.length; i++) {
                if (this.typesData.result.find(types => types.name == this.totalData.result[i].email)) {
                    this.totals.push({ value: this.totalData.result[i].value });
                }
            }
        }
    }
};
SystemGeneratedTasksPerUserComponent.ctorParameters = () => [
    { type: _services_http_service__WEBPACK_IMPORTED_MODULE_2__["HttpService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], SystemGeneratedTasksPerUserComponent.prototype, "subtitle", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["HostListener"])("window:resize", ["$event"])
], SystemGeneratedTasksPerUserComponent.prototype, "getScreenSize", null);
SystemGeneratedTasksPerUserComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-system-generated-tasks-per-user",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./system-generated-tasks-per-user.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/components/system-generated-tasks-per-user/system-generated-tasks-per-user.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./system-generated-tasks-per-user.component.scss */ "./src/app/modules/signage/components/system-generated-tasks-per-user/system-generated-tasks-per-user.component.scss")).default]
    })
], SystemGeneratedTasksPerUserComponent);



/***/ }),

/***/ "./src/app/modules/signage/pages/administrators/administrators.component.scss":
/*!************************************************************************************!*\
  !*** ./src/app/modules/signage/pages/administrators/administrators.component.scss ***!
  \************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21vZHVsZXMvc2lnbmFnZS9wYWdlcy9hZG1pbmlzdHJhdG9ycy9hZG1pbmlzdHJhdG9ycy5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/modules/signage/pages/administrators/administrators.component.ts":
/*!**********************************************************************************!*\
  !*** ./src/app/modules/signage/pages/administrators/administrators.component.ts ***!
  \**********************************************************************************/
/*! exports provided: AdministratorsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AdministratorsComponent", function() { return AdministratorsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AdministratorsComponent = class AdministratorsComponent {
    constructor() { }
    ngOnInit() {
    }
};
AdministratorsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-administrators',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./administrators.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/signage/pages/administrators/administrators.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./administrators.component.scss */ "./src/app/modules/signage/pages/administrators/administrators.component.scss")).default]
    })
], AdministratorsComponent);



/***/ }),

/***/ "./src/app/modules/signage/services/http.service.ts":
/*!**********************************************************!*\
  !*** ./src/app/modules/signage/services/http.service.ts ***!
  \**********************************************************/
/*! exports provided: HttpService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpService", function() { return HttpService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var angularfire2_firestore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! angularfire2/firestore */ "./node_modules/angularfire2/firestore/index.js");
/* harmony import */ var angularfire2_firestore__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(angularfire2_firestore__WEBPACK_IMPORTED_MODULE_3__);




let HttpService = class HttpService {
    constructor(afs, http) {
        this.afs = afs;
        this.http = http;
    }
    getFromFirestore(group, data) {
        let documentName = data;
        const groupWords = group.split(" ");
        for (const word of groupWords) {
            documentName += word;
        }
        if (group === "Accounts" ||
            group === "Laboratory" ||
            group === "Quality Assurance") {
            documentName += "User";
        }
        this.dataCollection = this.afs.collection("digital-signage", ref => {
            return ref.where("name", "==", documentName);
        });
        this.data = this.dataCollection.valueChanges();
        return this.data;
    }
};
HttpService.ctorParameters = () => [
    { type: angularfire2_firestore__WEBPACK_IMPORTED_MODULE_3__["AngularFirestore"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
HttpService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], HttpService);



/***/ }),

/***/ "./src/app/modules/signage/signage.module.ts":
/*!***************************************************!*\
  !*** ./src/app/modules/signage/signage.module.ts ***!
  \***************************************************/
/*! exports provided: SignageModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SignageModule", function() { return SignageModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _swimlane_ngx_charts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @swimlane/ngx-charts */ "./node_modules/@swimlane/ngx-charts/release/esm.js");
/* harmony import */ var _components_outstanding_tasks_per_group_outstanding_tasks_per_group_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./components/outstanding-tasks-per-group/outstanding-tasks-per-group.component */ "./src/app/modules/signage/components/outstanding-tasks-per-group/outstanding-tasks-per-group.component.ts");
/* harmony import */ var _pages_administrators_administrators_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./pages/administrators/administrators.component */ "./src/app/modules/signage/pages/administrators/administrators.component.ts");
/* harmony import */ var _components_custom_legend_custom_legend_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./components/custom-legend/custom-legend.component */ "./src/app/modules/signage/components/custom-legend/custom-legend.component.ts");
/* harmony import */ var _components_jobs_jobs_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./components/jobs/jobs.component */ "./src/app/modules/signage/components/jobs/jobs.component.ts");
/* harmony import */ var _components_custom_x_axis_custom_x_axis_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./components/custom-x-axis/custom-x-axis.component */ "./src/app/modules/signage/components/custom-x-axis/custom-x-axis.component.ts");
/* harmony import */ var _components_custom_y_axis_custom_y_axis_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./components/custom-y-axis/custom-y-axis.component */ "./src/app/modules/signage/components/custom-y-axis/custom-y-axis.component.ts");
/* harmony import */ var _components_system_generated_tasks_per_user_system_generated_tasks_per_user_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./components/system-generated-tasks-per-user/system-generated-tasks-per-user.component */ "./src/app/modules/signage/components/system-generated-tasks-per-user/system-generated-tasks-per-user.component.ts");
/* harmony import */ var _components_signage_slider_signage_slider_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./components/signage-slider/signage-slider.component */ "./src/app/modules/signage/components/signage-slider/signage-slider.component.ts");
/* harmony import */ var _components_custom_guage_chart_custom_guage_chart_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./components/custom-guage-chart/custom-guage-chart.component */ "./src/app/modules/signage/components/custom-guage-chart/custom-guage-chart.component.ts");
/* harmony import */ var _shared_shared_module__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../shared/shared.module */ "./src/app/modules/shared/shared.module.ts");
/* harmony import */ var _components_jobs_not_completed_jobs_not_completed_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./components/jobs-not-completed/jobs-not-completed.component */ "./src/app/modules/signage/components/jobs-not-completed/jobs-not-completed.component.ts");
/* harmony import */ var _components_booking_values_per_engineer_booking_values_per_engineer_component__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./components/booking-values-per-engineer/booking-values-per-engineer.component */ "./src/app/modules/signage/components/booking-values-per-engineer/booking-values-per-engineer.component.ts");
/* harmony import */ var _components_predicted_reds_ambers_per_user_predicted_reds_ambers_per_user_component__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./components/predicted-reds-ambers-per-user/predicted-reds-ambers-per-user.component */ "./src/app/modules/signage/components/predicted-reds-ambers-per-user/predicted-reds-ambers-per-user.component.ts");

















let SignageModule = class SignageModule {
};
SignageModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [
            _components_outstanding_tasks_per_group_outstanding_tasks_per_group_component__WEBPACK_IMPORTED_MODULE_4__["OutstandingTasksPerGroupComponent"],
            _pages_administrators_administrators_component__WEBPACK_IMPORTED_MODULE_5__["AdministratorsComponent"],
            _components_custom_legend_custom_legend_component__WEBPACK_IMPORTED_MODULE_6__["CustomLegendComponent"],
            _components_jobs_jobs_component__WEBPACK_IMPORTED_MODULE_7__["JobsComponent"],
            _components_custom_x_axis_custom_x_axis_component__WEBPACK_IMPORTED_MODULE_8__["CustomXAxisComponent"],
            _components_custom_y_axis_custom_y_axis_component__WEBPACK_IMPORTED_MODULE_9__["CustomYAxisComponent"],
            _components_system_generated_tasks_per_user_system_generated_tasks_per_user_component__WEBPACK_IMPORTED_MODULE_10__["SystemGeneratedTasksPerUserComponent"],
            _components_signage_slider_signage_slider_component__WEBPACK_IMPORTED_MODULE_11__["SignageSliderComponent"],
            _components_custom_guage_chart_custom_guage_chart_component__WEBPACK_IMPORTED_MODULE_12__["CustomGuageChartComponent"],
            _components_jobs_not_completed_jobs_not_completed_component__WEBPACK_IMPORTED_MODULE_14__["JobsNotCompletedComponent"],
            _components_booking_values_per_engineer_booking_values_per_engineer_component__WEBPACK_IMPORTED_MODULE_15__["BookingValuesPerEngineerComponent"],
            _components_predicted_reds_ambers_per_user_predicted_reds_ambers_per_user_component__WEBPACK_IMPORTED_MODULE_16__["PredictedRedsAmbersPerUserComponent"]
        ],
        imports: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"], _swimlane_ngx_charts__WEBPACK_IMPORTED_MODULE_3__["NgxChartsModule"], _shared_shared_module__WEBPACK_IMPORTED_MODULE_13__["SharedModule"]],
        exports: [_components_jobs_jobs_component__WEBPACK_IMPORTED_MODULE_7__["JobsComponent"], _components_signage_slider_signage_slider_component__WEBPACK_IMPORTED_MODULE_11__["SignageSliderComponent"]]
    })
], SignageModule);



/***/ }),

/***/ "./src/app/pages/accounting/accounting.component.scss":
/*!************************************************************!*\
  !*** ./src/app/pages/accounting/accounting.component.scss ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL2FjY291bnRpbmcvYWNjb3VudGluZy5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/pages/accounting/accounting.component.ts":
/*!**********************************************************!*\
  !*** ./src/app/pages/accounting/accounting.component.ts ***!
  \**********************************************************/
/*! exports provided: AccountingComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AccountingComponent", function() { return AccountingComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AccountingComponent = class AccountingComponent {
    constructor() { }
    ngOnInit() {
    }
};
AccountingComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-accounting',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./accounting.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/accounting/accounting.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./accounting.component.scss */ "./src/app/pages/accounting/accounting.component.scss")).default]
    })
], AccountingComponent);



/***/ }),

/***/ "./src/app/pages/administrators/administrators.component.scss":
/*!********************************************************************!*\
  !*** ./src/app/pages/administrators/administrators.component.scss ***!
  \********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL2FkbWluaXN0cmF0b3JzL2FkbWluaXN0cmF0b3JzLmNvbXBvbmVudC5zY3NzIn0= */");

/***/ }),

/***/ "./src/app/pages/administrators/administrators.component.ts":
/*!******************************************************************!*\
  !*** ./src/app/pages/administrators/administrators.component.ts ***!
  \******************************************************************/
/*! exports provided: AdministratorsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AdministratorsComponent", function() { return AdministratorsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AdministratorsComponent = class AdministratorsComponent {
    constructor() { }
    ngOnInit() {
    }
};
AdministratorsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-administrators',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./administrators.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/administrators/administrators.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./administrators.component.scss */ "./src/app/pages/administrators/administrators.component.scss")).default]
    })
], AdministratorsComponent);



/***/ }),

/***/ "./src/app/pages/developers/developers.component.scss":
/*!************************************************************!*\
  !*** ./src/app/pages/developers/developers.component.scss ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL2RldmVsb3BlcnMvZGV2ZWxvcGVycy5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/pages/developers/developers.component.ts":
/*!**********************************************************!*\
  !*** ./src/app/pages/developers/developers.component.ts ***!
  \**********************************************************/
/*! exports provided: DevelopersComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DevelopersComponent", function() { return DevelopersComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let DevelopersComponent = class DevelopersComponent {
    constructor() { }
    ngOnInit() {
    }
};
DevelopersComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-developers',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./developers.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/developers/developers.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./developers.component.scss */ "./src/app/pages/developers/developers.component.scss")).default]
    })
], DevelopersComponent);



/***/ }),

/***/ "./src/app/pages/directors/directors.component.scss":
/*!**********************************************************!*\
  !*** ./src/app/pages/directors/directors.component.scss ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL2RpcmVjdG9ycy9kaXJlY3RvcnMuY29tcG9uZW50LnNjc3MifQ== */");

/***/ }),

/***/ "./src/app/pages/directors/directors.component.ts":
/*!********************************************************!*\
  !*** ./src/app/pages/directors/directors.component.ts ***!
  \********************************************************/
/*! exports provided: DirectorsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DirectorsComponent", function() { return DirectorsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let DirectorsComponent = class DirectorsComponent {
    constructor() { }
    ngOnInit() {
    }
};
DirectorsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-directors',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./directors.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/directors/directors.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./directors.component.scss */ "./src/app/pages/directors/directors.component.scss")).default]
    })
], DirectorsComponent);



/***/ }),

/***/ "./src/app/pages/engineers/engineers.component.scss":
/*!**********************************************************!*\
  !*** ./src/app/pages/engineers/engineers.component.scss ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL2VuZ2luZWVycy9lbmdpbmVlcnMuY29tcG9uZW50LnNjc3MifQ== */");

/***/ }),

/***/ "./src/app/pages/engineers/engineers.component.ts":
/*!********************************************************!*\
  !*** ./src/app/pages/engineers/engineers.component.ts ***!
  \********************************************************/
/*! exports provided: EngineersComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EngineersComponent", function() { return EngineersComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let EngineersComponent = class EngineersComponent {
    constructor() { }
    ngOnInit() {
    }
};
EngineersComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-engineers',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./engineers.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/engineers/engineers.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./engineers.component.scss */ "./src/app/pages/engineers/engineers.component.scss")).default]
    })
], EngineersComponent);



/***/ }),

/***/ "./src/app/pages/home/home.component.scss":
/*!************************************************!*\
  !*** ./src/app/pages/home/home.component.scss ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL2hvbWUvaG9tZS5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/pages/home/home.component.ts":
/*!**********************************************!*\
  !*** ./src/app/pages/home/home.component.ts ***!
  \**********************************************/
/*! exports provided: HomeComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HomeComponent", function() { return HomeComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let HomeComponent = class HomeComponent {
    constructor() { }
    ngOnInit() {
    }
};
HomeComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-home',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./home.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/home/home.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./home.component.scss */ "./src/app/pages/home/home.component.scss")).default]
    })
], HomeComponent);



/***/ }),

/***/ "./src/app/pages/login/login.component.scss":
/*!**************************************************!*\
  !*** ./src/app/pages/login/login.component.scss ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL2xvZ2luL2xvZ2luLmNvbXBvbmVudC5zY3NzIn0= */");

/***/ }),

/***/ "./src/app/pages/login/login.component.ts":
/*!************************************************!*\
  !*** ./src/app/pages/login/login.component.ts ***!
  \************************************************/
/*! exports provided: LoginComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoginComponent", function() { return LoginComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_auth_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../services/auth.service */ "./src/app/services/auth.service.ts");



let LoginComponent = class LoginComponent {
    constructor(auth) {
        this.auth = auth;
    }
};
LoginComponent.ctorParameters = () => [
    { type: _services_auth_service__WEBPACK_IMPORTED_MODULE_2__["AuthService"] }
];
LoginComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-login',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./login.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/login/login.component.html")).default,
        changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectionStrategy"].OnPush,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./login.component.scss */ "./src/app/pages/login/login.component.scss")).default]
    })
], LoginComponent);



/***/ }),

/***/ "./src/app/pages/not-found/not-found.component.scss":
/*!**********************************************************!*\
  !*** ./src/app/pages/not-found/not-found.component.scss ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL25vdC1mb3VuZC9ub3QtZm91bmQuY29tcG9uZW50LnNjc3MifQ== */");

/***/ }),

/***/ "./src/app/pages/not-found/not-found.component.ts":
/*!********************************************************!*\
  !*** ./src/app/pages/not-found/not-found.component.ts ***!
  \********************************************************/
/*! exports provided: NotFoundComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NotFoundComponent", function() { return NotFoundComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let NotFoundComponent = class NotFoundComponent {
    constructor() { }
    ngOnInit() {
    }
};
NotFoundComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-not-found',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./not-found.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/not-found/not-found.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./not-found.component.scss */ "./src/app/pages/not-found/not-found.component.scss")).default]
    })
], NotFoundComponent);



/***/ }),

/***/ "./src/app/services/auth.service.ts":
/*!******************************************!*\
  !*** ./src/app/services/auth.service.ts ***!
  \******************************************/
/*! exports provided: AuthService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthService", function() { return AuthService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_fire_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/fire/auth */ "./node_modules/@angular/fire/auth/es2015/index.js");
/* harmony import */ var _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/fire/firestore */ "./node_modules/@angular/fire/firestore/es2015/index.js");
/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! firebase/app */ "./node_modules/firebase/app/dist/index.cjs.js");
/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(firebase_app__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");








let AuthService = class AuthService {
    constructor(router, fireAuth, fireStore) {
        this.router = router;
        this.fireAuth = fireAuth;
        this.fireStore = fireStore;
        this.user = this.fireAuth.authState.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["switchMap"])(user => {
            if (user) {
                return this.fireStore.doc('users/' + user.uid).valueChanges();
            }
            else {
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(null);
            }
        }));
    }
    googleSignin() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const provider = new firebase_app__WEBPACK_IMPORTED_MODULE_6__["auth"].GoogleAuthProvider();
            const credential = yield this.fireAuth.auth.signInWithPopup(provider);
            this.router.navigate(['']);
            return this.updateUserData(credential.user);
        });
    }
    signOut() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            yield this.fireAuth.auth.signOut();
            return this.router.navigateByUrl('/');
        });
    }
    updateUserData({ uid, email, displayName, photoURL }) {
        const userRef = this.fireStore.doc('users/' + uid);
        const data = {
            uid,
            email,
            displayName,
            photoURL
        };
        return userRef.set(data, { merge: true });
    }
};
AuthService.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"] },
    { type: _angular_fire_auth__WEBPACK_IMPORTED_MODULE_4__["AngularFireAuth"] },
    { type: _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_5__["AngularFirestore"] }
];
AuthService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], AuthService);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false,
    firebase: {
        apiKey: "AIzaSyA-Bxa2lQMeCbpe309UDwTSFhbNa4S0Msw",
        authDomain: "tlabs-api.firebaseapp.com",
        databaseURL: "https://tlabs-api.firebaseio.com",
        projectId: "tlabs-api",
        storageBucket: "",
        messagingSenderId: "935262488148",
        appId: "1:935262488148:web:3b18a9e7d16ee552"
    }
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");





if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! C:\Users\Richard\Documents\_00digital-signage\digital-signage\src\main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map